const enUS = {
    button: {

    },
    login: {
        LOGIN_LOGIN: 'SIGN IN',
        RESET: 'RESET',
        LOGIN_FGT_PWD: 'forget the password?',
        LOGIN_REGISTER: 'register',
        LOGIN_ACCOUNT: 'please enter user name',
        PASSWORD: 'Please enter your password!',
        TITLE: '用户登录',
        ACCOUNT: "ACCOUNT",
        PASSWORD_PASSWORD: "PASSWORD",
        "欢迎使用OMS":"Welcome to OMS",
        "账号密码":"Account",
        "验证码":"Verification Code",
        "账号手机号码":"Account/Phone Number",
        "密码":"Password",
        "手机号码":"Phone Number",
        "获取验证码":"Obtain code",
        "登录/注册":"Login/Register",
        "若手机号码尚未注册将为您自动注册账户":"If the phone number has not been registered yet, it will be automatically registered for you",
        "请输入手机号码":"Please enter your phone number",
        "登录失败":"Login failure",
        "登录成功":"Login success",
        "请填写正确的手机号码":"Please enter the correct phone number",
        "秒":"Seconds",
        "重置密码": "Reset Password",
        "欢迎登陆":"Welcome to",
        "跨境V5":"the Cross border V5",
        "云平台":"Cloud Platform",
        "邮件验证码":"Email verification code",
        "账号":"Account",
        "新密码":"Enter the new password",
        "再次输入新密码":"Enter the new password again",
        "确定":"Submit",
        "返回登录":"Return to login",
        "请输入账号":"Please enter your account",
        "请输入邮件验证码":"Please enter Email verification code",
        "密码必须包含: 数字, 大写字母, 小写字母, 特殊字符, 最短长度12位":"The password must contain digits, lowercase letters, uppercase letters, and special characters. The minimum length is 12 characters",
        "新密码与确认密码不一致":"The new password is different from the confirmed password",
        "请输入新密码":"Please enter your new password",
        "邮箱验证码": "Email Verification Code",
        "获取验证码": "Get Code",
        "返回登录": "Return to login",
        "秒": "S",
        "旧密码": "Enter the old password",
        "请输入旧密码旧密码": "Please enter the old password",
        "同一设备每14天需重新认证一次": "The same device needs to be re certified every 14 days",
        "已经发送到": "Already sent to",
        "请输入邮箱验证码": "Please enter the email verification code",
        "请输入旧密码": "Please enter a old password",
        "请输入新密码": "Please enter a new password",


    },
    Main: {
        "网络连接中断！": "The network connection is interrupted! ",
        "系统版本有更新，点击确认加载最新，或按【CTRL + F5】！": "The system version has been updated, click to confirm to load the latest version, or press [CTRL + F5]! ",
        "系统提示": "System Hint ",
        "您已打开过多的窗口，请关闭暂时不用的窗口后重新打开": "You have opened too many windows, please close the windows you don’t use and reopen them ",
        "未授权，请重新登录": "Unauthorized, please log in again ",
        "错误请求": "Bad request ",
        "拒绝访问": 'Access denied',
        "请求错误，未找到该资源": "Request error, the resource was not found",
        "请求方法为允许": "The request method is allowed ",
        "请求超时": "Request timed out",
        "服务器端出错": "Server-side error",
        "网络未实现": 'Network not implemented',
        "网络错误": "Network error",
        "服务不可用": "Service unavailable",
        "网络超时": "Network timeout",
        "http版本不支持该请求": 'HTTP version does not support the request',
        "网络连接超时，请稍候重试": "Network connection timed out, please try again later",
        "网络中断，请检查网络是否正常": "The network is interrupted, please check whether the network is normal ",
        "连接错误": "Connection error ",

    },
    menu_left: {
        "创建订单": "Create Order ",
        "单票录入": "Order Create",
        "批量导入": "Batch Upload",
        "订单管理": "Order List",
        "发货记录": "Delivery Record",
        "扫描打印": "Print AWB",
        "问题处理": "Troubleshooting",
        "报价查询": "Get a Quote",
        "集运单管理": "Consolidation Bill Management",
        "签收时效监控": "Signing Time Monitoring",
        "清关订单导入": "Clearance Order Import",
        FBA: 'FBA',
        "我的余额":"My Balance",
        "账单管理":"Billing Management",
        "账单明细":"Bill Details",
        "升级B端客户":"Upgrade B-end customers",
        // "平台配置":"Platform configuration",
    },
    menu: {
        home: 'Home',
        OMSHOME: 'OMSHOME',
        configManage: 'Config manage',
        tenantManage: 'TenantManage',
        organization: 'Organization',
        Order: 'Order',

        TMS124: "平台指定路线策略",
        TMS123: '接驳单管理',
        TMS125: '平台货物类型策略',
        TMS126: "报表分区",
        BIS026: "货态统计报表",
        BIS0261: "货态统计报表明细",
        TMS127: '货态比对策略',
        TMS127001: '货态比对策略导入',
        TMS128: '货态订阅方案',
        TMS133: 'Mapping status description',
        cargoImport: 'Import cargo description mapping',
        BIS027: "货态比对报表",
        BIS0271: '货态比对报表明细',
        BIS028: "货态货量报表",
        BIS0281: '货态货量报表明细',
        BIS029: "干线货态监控报表",
        BIS0291: '干线货态监控报表明细',
        BIS030: '出货空运统计报表',
        BIS0301: '出货空运统计报表明细',
        BIS031: '签收时效监控报表',
        BIS0311: '签收时效监控报表明细',
        BIS032: 'ShoppeAPI预报监控报表',
        BIS0321: 'ShoppeAPI预报监控报表明细',
        BIS035: '客户签收时效报表',
        BIS0351: '客户签收时效报表明细',
        BIS036: '客户营业额报表',
        BIS0361: '客户营业额报表明细',
        BIS034: 'WISH时效货量统计报表',
        BIS0341: 'WISH时效货量统计报表明细',
        BIS033: '仓库库存报表',
        BIS037: 'shoppe马来预报货量',
        KENG03: "Import sort code",

        TMS0129: "入库大包号导入",

        OMS044: "Signing Time Monitoring",
        OMS0441: "Signing Time Monitoring Detail",
        OMS045: 'Clearance Order Import',
        BAS02522: 'Print config',
        TMS046: 'Parameter settings',
        CMNOO1: 'Sys env config',
        BAS003: 'Hub manage',
        BAS004: 'Position role',
        BAS007: 'Option setting',
        LOG001: 'System log',
        BAS013: 'Customer manage',
        BAS016: 'Shipment status',
        strategyorders: 'Order',
        strategyoper: 'Operate',
        strategyagent: 'Acting',
        BAS043: 'Product name rules',
        BAS041: 'TN# rules',
        BAS062: 'API account config',
        BAS026: 'Proxy EDI config',
        BAS024: 'TN# rules',
        BAS064: 'Platform order download',
        Opeer: 'Operate',
        Return: 'Return order',
        Trunk: 'Line haul',
        Problem: 'Exception handling',
        1: 'After linehaul',
        TMS: 'Before linehaul',
        CustServ: 'Customer service',
        QuoteCust: 'Client',
        QuoteDelivery: 'Delivery agent',
        QuoteTran: 'Carrier Agent',
        Quote5: 'Internal',
        Quote7: 'C/C Settings',
        Quote6: 'Check Quotation',
        BMS069: "AR Whole bag",
        BMS070: 'AR Collection fee',
        SettlementRules: 'Settlement rules',
        BMS090: 'Cost of revenue rule',
        CustomerSettlement: 'Receivable settlement',
        BMS030: 'Waybill settlement details',
        BMS807: 'Summary of monthly votes',
        COD: 'Loan settlement',
        feeReimburse: 'Reimbursement',
        BIS: 'Report',
        custType: 'Customer',
        operation: 'Operation',
        BIS014: 'Shipment forecast daily report',
        BIS010: 'Operation workday report',
        shipType: 'Carrier',
        BISJIE: 'Settlement',
        BISMaoLi: 'Gross profit',
        BISSales: 'Sales',
        BIS009: 'Company gross profit analysis',
        CRM: 'CRM',
        Monitor: 'Monitor',
        BAS001: '首页设置',
        base: 'Base Info',
        sortpartition: "Sort partition",
        strategy: 'Tactics',
        JOB33: "取消小包管理",
        downloadorder: 'Platform download order',
        Authorization: '平台授权',
        downloadthelog: '下载日志',
        TMS094: '运单录入',
        TMS09402: '运单修改',
        TMS09403: '运单补录',
        TMS09401: '凡达',
        TMS101: '运单审单',
        JOB34: "取消大包管理",
        fdorderxuzw: '凡达录单-xuzw',
        OMS002: 'Order Create',
        OMS0021: '单票修改',
        OMS0022: '单票浏览',
        TMS0921: '单票修改',
        TMS0922: '单票浏览',
        asyncOrderInput: '异常订单修改',
        TMS091: 'Order Import 2',
        BAS002: 'Company settings',
        BAS070: 'Push status config',
        BAS005: 'StaffManage',
        statManage: 'WarehouseManage',
        roleManage: 'roleManage',
        BAS006: 'AuthorizationManage',
        optionSetting: 'Option setting',
        TMS061: '出货变更',
        TMS098: '派件',
        TMS099: '签收',
        SettIementl: '结算',
        SYS007: 'APP upgrade',
        SYS008: 'Import settings',
        SYS006: 'Platform config',
        SYS005: 'Platform options',
        SYS001: 'Level 1 module settings',
        SYS002: 'Platform menu settings',
        SYS003: 'Sales section settings',
        SYS004: 'Platform role',
        SYS098: '字典配置',
        tenantSetting: '租户设置',
        SettlementPayable: 'Payable settlement',
        template: '标准模板',
        template1: '标准模板一',
        employee: '员工管理模板',
        userManage: '用户管理',
        userInfo: '用户资料',
        userData: '用户数据',
        deviceManage: '设备管理',
        statusManage: '状态监控',
        bill: 'Shipment order(暂停)',
        // TMS: '运单查询',
        menumag: '菜单管理',
        customerconnection: '客户对接授权',
        dockingset: '对接设置',
        transferanalysis: '转运分析',
        statmag: '网点管理',
        quote: 'Product Quotation',
        BAS009: 'Channel code',
        BAS010: 'Deliver route',
        destlimit: '目的地限制服务',
        BAS011: '排仓分区规则',
        BAS028: 'CustGroup',
        BAS022: 'Carry rule',
        BAS023: 'Calculating & tossing rules',
        BAS017: 'Problem status',
        BAS018: 'Subject manage',
        BAS100: 'Shopee Service Code',

        BAS019: 'Exchange rate settings',
        BAS106: 'Declared Exchange Rate',
        BAS10601: 'Declared Exchange Rate Import',
        BAS020: '排货策略',
        BAS021: '分拣策略',
        BAS008: 'DestinationManage',
        BAS029: 'Billing formula',
        BAS030: 'Fund account',
        BAS031: 'AR AP Subject',
        BAS035: 'Status mapping rules',
        scanManage: 'Scan status',
        BAS072: 'Accept Email',
        BAS073: 'C/C Status Mapping Rules',
        BAS060: 'Encoding rules',
        BAS067: 'Sort code',
        BAS101: 'Sales commission setting',
        BAS10101: 'Sales commission ratio setting',
        BAS10102: 'Sales commission setting import',
        BAS102: 'Route estimated gross profit',
        BAS10201: 'Route estimated gross profit import',
        BIS041: 'The company withholding number',
        BIS04101: 'The company withholding number detail',
        BIS040: "Sales commission report",
        BIS04001: "Sales commission report detail",
        TMS102: '取消小包',
        TMS103: '取消大包',
        MOA001: 'Spider status',
        MOA003: 'Tracking push',
        MOA004: 'Kafka Log',
        MOA005: 'Platform API',
        MOA007: 'Coral COD',
        MOA008: '清关数据推送监控',
        MOA010: "异步下单监控",
        MOA011: "邮件推送监控",
        MOA012: '保险邮件推送',
        MOA013: 'KEC ERP 监控',
        MOA014: 'spider文件对接监控',
        MOA015: "安踏9610监控",
        custManage: 'custManage',
        waybilltomodify: '运单修改',
        TMS068: '运单自动追踪规则',
        changeaudit: '变更审核',
        BMS078: 'AR shipment settings 2',
        BMS07801: 'AR shipment settings add',
        BMS07802: 'AR shipment settings modify',
        BMS07803: 'AR shipment settings copy',
        BMS07804: 'AR shipment settings view',
        BMS001: 'AR shipment settings',
        BMS0011: 'AR shipment settings',
        BMS1011: '应收运费新增',
        BMS101: '应收运费新增',
        BMS102: '应收运费修改',
        BMS104: '应收运费复制',
        BMS103: '应收运费浏览',
        BMS002: 'AR Fuel',
        BMS012: 'AR',
        BMS013: 'AP',
        BMS003: 'AR premium',
        BMS010: 'AP Fuel',
        BMS011: 'Remote query',
        BMS009: 'AP shipment',
        quoteDestZone: '分区设置',
        BMS019: 'Customer fee import',
        BMSAdd: 'Import expense re-entry ',
        BMSAddedFee: '增值费导入',
        BAS066: 'Cargo type strategy ',
        BMSAddQuoteHubIm: 'Import special quotation',
        BMSAddQuoteHubCustIm: 'Import associated customers',
        TMS0137: 'Import current customer quotes',
        BMSOawb: "承运账单明细导入",
        BMSAgeent: "派送费用导入",
        BMS059: 'Carryover at the end of the month',
        BMS059001: 'Carryover at the end of the month Detail',
        BMS071: 'Carriage cost sharing',
        BMS0711: '分摊明细',
        BMS0712: '分摊明细',
        BMS0713: '分摊明细',
        BMS085: 'Other cashier',
        BMS081: 'AP collection fee',
        BMS109: '应付派送运费浏览',
        BMS110: '应付派送运费新增',
        BMS113: '应付派送运费复制',
        BMS111: '应付派送运费修改',
        BMS086: 'AP other',
        AuditBillDetails: '派送对账审核',
        AgentBillMaoLi: '对帐毛利分析',
        BMS0321: '派送费用录入',
        productcontrolrules: 'Product comparison rules ',
        TMS0130: "退件登记",

        BAS065: 'Name manage',
        BAS068: '在线充值规则',
        BAS069: 'Status Mapping Rules',
        // BIS038:"时效监控报表",

        TMS0128: '清关订单导入',
        TMS129: "菜鸟无主件扫描",
        productnameimport: 'Product control import ',
        TMS0302: '清仓管理',
        TMS0301: '清仓明细',
        TMS0303: '清仓明细',
        TMS069: '来货上架',
        TMS070: '查货',
        TMS072: '收货上架',
        TMS078: 'Shipment order2',
        TMS121: 'Waybill management',
        TMS122: 'Delete Order ',
        TMS123001: '接驳单导入',
        speciallineremotedata: '专线偏远资料',
        test: '测试',
        TMS089: '入库预查',
        BMSWeig: '重量段设置',
        BMS076: 'Weight compensation rules',
        TMS007: '排货',
        receivingbag: '收货装包',
        warehousing: 'Inbound',
        output: 'outbound',
        TMS002: '收件录单',
        pcsauto: '单件称重',
        TMS028: '打单审核',
        TMS030: '清仓',
        TMS060: '条码打印',
        TMS003: '快速收货',
        TMS006: 'Shipment order',
        TMS095: 'Invoice查询',
        TMS09501: 'Invoice导入修改',
        TMS0061: 'Invoice明细',
        TMS004: 'Receiving package mgmt',
        TMS00901: '装包扫描',
        TMS065: '上板',
        TMS06503: '拆板',
        TMS071: '班次交接',
        TMS077: '在途跟踪',
        TMS07101: '班次管理',
        TMS07102: 'COPY扫描',
        TMS07103: '总运单发送',
        TMS07104: '班次交接完成',
        TMS07105: '上板完成(关联班次)',
        TMS074: '班次轨迹追踪',
        TMS07401: '班次轨迹追踪明细',
        TMS010: 'Linehaul manage',
        TMS120: 'ShipmentBatchManage',
        MOA006: 'Outbound Push',
        MOA009: 'Restart Push',
        outboundLogDtl: 'Outbound Detail',
        shipment2: 'Shipment',
        shipment2details: 'ShipmentBatch details',
        TMS014: 'Issue register',
        TMS015: 'Issue process',
        TMS016: 'Issue info',
        problemsqueryprocessed: '已处理完毕港前问题件',
        TMS057: 'Issue register',
        TMS058: 'Issue process',
        TMS059: 'Issue info',
        CRM010: 'After linehaul issue info',
        TMS06701: '运单附件上传',
        TMS06702: '运单附件修改',
        TMS067: '运单附件管理',
        TMS079: '车辆管理',
        TMS080: '调度区域',
        TMS082: '取件申请',
        CRM007: '取件申请',
        TMS086: '交货上架',
        TMS088: '正常扫描',
        TMS084: '退件入库',
        TMS085: '退件出库',
        TMS083: '调度查询',
        TMS087: '交货查询',
        TMS081: '调度管理',
        TMS108: 'issue register',
        TMS109: 'issue process',
        TMS110: 'issue info',
        TMS111: '代理问题件登记',
        TMS112: '代理问题件处理',
        TMS113: '代理问题件查询',
        TMS114: 'C/C Route',
        bounnemanagement: 'bounnemanagement',
        TMS017: 'Return customer',
        TMS076: 'Order Number Modify',
        TMS018: 'Returned into storage',
        TMS019: 'Order Tracking',
        TMS093: '面单套打',
        TMS0134: "抖音无主件扫描",
        TMS0135: '无主件处理',
        TMS013501: '无主件处理导入',
        TMS096: '国内抵达',
        domesticarrivemanage: '抵达管理',
        TMS097: '进口到件',
        TMS100: '进口查询',
        quantityDetail: "货量情况",

        trajectorytrackingimport: 'Batch import tracks ',
        custlogimport: 'Import customer service logs ',
        // ghwtjimport:'港后问题件批量导入',
        gqwtjimport: 'upload issue',
        TMS020: 'Tracking',
        OMS005: '代理打单',
        POS003: '打单查询',
        frameHtml: 'HTML打印',
        printimport: '打单导入',
        printcustomizeimport: '打单自定义导入',
        BAS059: '自动转单规则',
        scanPrint: 'Scan print',
        POS011: '运单推送',
        OMS006: '打单审核',
        authorization: '平台授权',
        apiauth: 'API授权',
        OMS015: 'Print AWB',
        OMS0181: '导入修改',
        OMS017: '取件申请',
        POS004: '转单分配规则',
        addTrackNoPool: '新增号码段（号码池）',
        trackNoPoolUsage: "单号使用情况",
        POS005: '运单分配规则',
        ediparameter: 'EDI字段参数',
        transferOrderConfig: '客户转单配置',
        customerFieldConfig: '客户字段配置',
        BMS031: 'Delivery statement import',
        BAS012: '英文品名规则',
        POS025: '黑名单规则',
        BAS053: '寄件随机名单',
        randomrulesimport: '寄件随机名单导入',
        BAS050: '打单导入分解',
        BMS032: 'Delivery bill details',
        BMS075: '客户重量补差',
        BMS0751: '客户重量补差_1',
        BMS033: 'Delivery statement management',
        BMS038: 'Agent bill management',
        BMS0381: 'Agent bill management detail',
        BMS0382: '承运账单明细数据',
        managewaybill: 'Linehaul manage',
        sendwaybill: 'Linehaul detail',
        applyfor: 'EDI申请情况',
        ediUse: 'EDI使用情况',
        waybilldetails: '总运单详情',
        agencyedi: '代理EDI接口',
        TMS009: 'Box management',
        upperboardmanagement: '上板管理',
        bagdetails: 'Box Detail',
        upperboarddetails: '板中详细',
        selectionwaybill: '选取运单',
        exporttemplatemanagement: '导出模板管理',
        exportset: 'Export settings',
        BMS028: 'Outbound route',
        BMS020: 'Customer billing details',
        BMS082: 'Customer unlock query',
        BMS004: '包装费设置',
        BAS025: '打印配置',
        BAS027: '装包策略',
        BAS044: '上板策略',
        BAS071: 'Shipment Batch',
        BAS040: '单号验证规则',
        BMS007: 'AR remote fee',
        BMS072: 'Cost of revenue rule',
        BMS073: 'COD import',
        BIS002: 'Gross profit analysis of product',
        BIS0021: 'Gross profit analysis of product detail',
        BIS012: 'Customer Aging Report',
        BIS013: 'Funds in and out report',
        BIS017: 'Customer delivery report',
        BIS018: 'Accounts Receivable Aging Analysis Table',
        BIS038: 'Accounts Receivable Aging Analysis Table',
        BIS03801: 'Detailed page of receivable aging analysis',
        BIS019: 'Overdue Aging Analysis Table',
        BIS020: 'Statistics of overdue uncollected payments',
        BIS0131: 'Funds in and out report Detail',
        BIS007: 'Point gross profit analysis',
        BIS024: 'Cargo Statistics Report',
        BIS0241: "Cargo Statistics Report Detail",
        BMS006: 'AR packaging fee',
        BMS006001: '其他汇率',
        BAS014: 'Shipper Management',
        BAS015: 'Public recipient ',
        BAS056: '货位管理',
        BMS092: 'Single ticket price',
        BAS037: 'AgentManage',
        BAS045: 'Operation log',
        BAS046: 'Parameter settings',
        BAS055: '17单号规则',
        BAS058: 'SMS settings',
        TMS005: '运单录入',
        BalanceManage: '余额查询',
        BillChange: '账单变更',
        BillMag: '账单管理',
        BMS021: 'Customer bill management',
        BMS024: 'Customer bill merge management',
        BMS0241: 'Customer merge bill details',
        BMS0211: 'Customer bill details',
        BMS0212: 'Package bill details',
        BMS022: 'Customer balance',
        BMS0221: '客户往来明细',
        BMS0222: '待审明细',
        BMS022001:"Details of Withholding Fees",
        notreceivebag: '未收货包',
        openorder: '未收货订单',
        waitwaybillsubmit: '待提交运单',
        bagreceive: 'Whole bag receipt',
        customerroutingrules: '客户打单规则',
        spiderTrajectoryDetail: 'Spider Trajectory Detail',
        BAS042: '重量采集设置',
        BMS008: 'AR other',
        BMS122: 'AR value-added',
        BMS023: 'Package bill details',
        BMS02301: '客户帐单明细(包)导入修改',
        BMS02302: '客户帐单明细(包)分摊明细',
        BMS025: 'AP linehaul',
        BMS0251: '新增承运报价',
        BMS0252: '修改承运报价',
        BMS0253: '复制承运报价',
        BMS074: 'AP Cost of Sales',
        BMS077: 'AP Sales cost query',
        BMS083: 'AP Internal pickup',
        BMS0250: '应付承运商费用',
        BMS026: 'AP Internal cost',
        BMS037: 'Carriage bill details',
        BMS0371: '承运账单明细导入',
        BMS034: 'Agent balance management',
        BMS035: 'Agent transaction report detail',
        BMS084: 'Expense supplement',
        BMS094: 'Supplement AP',
        BMS093: 'Agent fee supplement management',
        BMS098: '出口账单明细',
        BMS099: '进口账单明细',
        BMS095: '客户账单管理2',

        CMN004: '发件箱查询',
        CMN005: 'Report export',
        CMN006: "Export of Waybill Attachment",
        BAS034: '运单追踪设置',
        BAS032: '目的地策略',
        BAS038: '干线追踪设置',
        BAS036: 'OMS authorization',
        BAS057: '发件箱设置',
        Cashier: 'Cashier',
        CustCollect: 'Client payment',
        BMS044: 'Customer collection registration',
        BMS096: 'Customer collection registration2',
        BMS097: 'Customer Collection Management2',
        BMS0971: '客户收款浏览',
        BMS049: 'Customer reconciliation report',
        BMS0491: '资金帐户往来明细',
        TMS024: 'upload order',
        CRM008: 'upload order',
        TMS090: '专线导入',
        OMS003: 'Order import',
        FBA: 'FBA',
        OMSImport: 'Order Batch Upload',
        OMS004: 'Order list',
        OMS018: 'Order List',
        OMS0041: '订单-单笔修改',
        OMS0042: '订单详情',
        OMS043: '集运单管理',
        TMS063: 'Waybill import modification ',
        BMS060: 'Customer Collection Management',
        accounttransfer: 'Account transfer',
        waybillsettlement: 'Waybill settlement details',
        reimbursement: '费用报销管理',
        reimbursementr: '费用报销登记',
        operatingworkload: '操作工作量日报表',
        operatingworkloaddetail: '操作工作量明细',
        shipmentreport: '出货预报日报表',
        shipmentreportdetail: '出货预报日报表明细',
        BMS06001: '客户收款修改',
        BMS06002: '应收账单确认',
        BMS06003: '应收账单确认(包单)',
        BMS06006: '客户收款浏览',
        BMS061: '客户现金缴款',
        BMS062: 'Customer collection review',
        BMS06201: '收款审核',
        BMS063: 'Customer write-off management',
        BMS06301: '账单核销明细',
        BMS06302: '帐单确认异常明细',
        BMS040: 'Agent payment',
        BMS041: '内部转账',
        BMS042: '其他调账',
        BMS043: '核销管理',
        BMS048: '账户余额管理',
        BMS045: 'Agent payment application',
        BMS064: 'Agency payment management',
        BMS0641: '代理付款修改',
        BMS0642: '代理付款浏览',
        BMS065: '代理付款审核',
        BMS066: 'Agent payment',
        BMS0661: '代理付款审核确认',
        BMS0651: '代理付款审核确认',
        BMS067: 'Agency verification management',
        BMS0671: '账单核销详情',
        CRM012: 'Order Create',
        CRM018: '销售员杂费报价',
        CMN10010:"Self pickup point query",
        CRM017: 'Salesperson commission config',
        CRM016: '销售员底薪设置',
        CRM014: 'Customer Quotation',
        CRM013: 'Upload order2',
        //货款
        BMS014: 'COD payment',
        BMS015: 'Receipt statement import',
        BMS0151: '回款对账单审核',
        BMS016: 'Receipt statement management',
        BMS017: 'COD receipt bill',
        BMS0171: 'COD receipt bill detail',
        BMS0172: '查看回款水单',
        BMS018: 'COD rebate',
        BMS068: 'COD rebate bill',
        BMS0681: 'COD rebate bill detail',
        BMS0682: '查看返款水单',
        BMS8071: '统计明细数据',
        orderedi: '订单EDI',
        ediopen: 'EDI开通',
        BAS061: 'Label design',
        BAS063: 'Order download log ',
        cargotypestrategy: '货物类型策略',
        designatedroutestrategy: '指定路线规则',

        BMS046: 'Reimbursement',
        BMS047: 'Reimbursement payment',
        BMS079: 'Account transfer',
        BMS080: 'Cashier details',
        BMS091: 'Salesperson Cost Query',
        BIS015: 'Customer transaction report',
        BIS0151: 'Customer transaction report detail',

        BIS011: 'Fund account management',
        transshipment: 'Transport',
        TMS012: 'Transshipment',
        TMS0126: "ICBU中心仓工单",
        TMS134: '菜鸟Tracepush',
        TMS135: 'SLA复核',
        TMS136: 'Shopee节点推送',
        TMS0121: '转运发件管理',
        TMS0122: '转运发送',
        TMS0123: '转运单明细',
        TMS0124: '转运分析',
        TMS013: 'Transfer to piece',
        TMS0131: '转运到件管理',
        TMS0132: '转运到达',
        TMS0133: '转运单明细',
        TMS032: 'Upload linehaul status',
        TMS062: 'Change review ',
        TMS0621: '运单修改',
        TMS00102: '预报修改',
        TMS00103: '导入修改',
        TMS073: '专线录单',
        TMS075: '单证预查',
        OMS0071: '运单详情',
        TMS001: 'Order pre-alert',
        TMS092: 'Order Create',
        orderinput: 'Order Create',
        TMS00101: 'shopeeAPI forecast',
        quotehubbagging: '应收整包运费',
        quotecommission: 'AR Collection fee',
        quotecommission001: 'AR Collection fee Import',
        inspection: '查货',
        BMS120: 'AR special remote fee',
        BMS121: 'Remote fee',
        importspecialcost: '专线偏远导入',
        // OMS008:'问题件',
        OMS008: 'Troubleshooting',
        OMS0081: 'Problem',
        trackquery: 'Track query',
        OMS007: 'Delivery Record',
        gxgjglimport: '导入轨迹',
        zydglimport: '补录导入',
        zydzdimport: '子运单箱号关系导入',
        TMS130: '集运客户管理',
        Consolidation: "集运",
        TMS131: "集运单管理",
        TMS132: '集运单退货',
        TMS137: '集运单普敏转换',
        TMS138: '拼多多拒签',
        TMS139: '拼多多无主件扫描',
        orderPrint: '代理打单',
        agenttoplaysingle: '代理打单',
        agenttoplaysingleadvance: '预打单',
        deliveryrecord: '发货记录',
        OMS009: 'Get a Quote',
        OMS012: '账单管理',
        OMS016: '账单明细',
        OMS0121: '账单明细',
        OMS0122: '账单明细（包）',
        OMS010: '偏远查询',
        OMS011: '我的余额',
        OMS0111: '待审明细',
        //BIS
        BIS001: 'Customer Shipment Day Report',
        BIS0011: '当日预报明细',
        BIS0012: '历史收件明细',
        BIS0013: '当日收件明细',
        BIS003: 'Warehouse operation daily report',
        BIS0031: '仓库操作明细',
        BIS005: 'Timeliness Report for Trunk Transportation',
        BIS023: 'Agent transaction report',
        BIS0231: 'Agent transaction report detail',
        BIS004: 'Cost of Revenue Source Quotation',
        companyanalysis: 'Company gross profit analysis',
        companyanalysisdetail: 'Company gross profit analysis detail',
        BIS006: 'Gross margin analysis of total air waybill',
        BIS0061: 'Gross margin analysis of total air waybill detail',
        BIS008: 'Point gross profit analysis',
        BIS0081: '网点运营毛利明细',
        BIS0082: '网点销售毛利明细',
        BIS016: 'Sales customer report',
        BIS0161: 'Sales customer report detail',

        BIS021: '寄件人发货月报表',
        BIS0211: '预报明细',
        BIS0212: '收件明细',
        BIS022: 'Salesperson gross profit statistics',
        BIS0221: 'Salesperson gross profit statistics detail',




        CMN001: '系统环境配置',
        CMN002: 'News',
        CMN003: '短信',
        shortmessageimport: '短信导入',
        BMS123: 'PiJia task',
        BMS1231: 'Task details',
        BMS124: 'Delivery PiJia task',
        BMS1241: 'Delivery PiJia Task details',
        CRM001: 'Customer view',
        CRM002: 'Waybill view',
        CRM003: 'Salesperson Settings',
        CRM004: 'Salesperson Statistical Report',
        CRM0041: 'Salesperson Statistical Report detail',
        CRM005: 'Before linehaul issue info',
        CRM006: 'After linehaul issue info',
        CRM009: '订单预报',
        CRM0091: '单票修改',
        CRM011: 'Single ticket price',
        BMS100: '销售员成本单票报价',
        CRM015: 'Sales quota management',
        pulldownBagging: '拆包',
        CRM015001: "销售员解锁记录查询",
        CMN150: "Timed export of reports",
        OMS050:"Upgrade B-end customers",
        BAS103: "Approval List",
        OMS022001: "Details of Withholding Fees",
        TMS050: "Sale Confirmation",
        TMS051: "Product Validation",
    },
    hint: {
        switchLanguageSuccess: "switch language success",
    },
    "page": {
        "SYS001": {

        }
    },
    "oms": {
        "入库日期": "Scan-in date",
        "产品码分类": "Channel code classification",
        "产品码": "Channel code",
        "分组数据": "Grouping data",
        "支持多选": 'Multiple choice',
        "查询": "Search",
        "重置": "Reset",
        "导出": "Export",
        "数据更新时间": "Data update time",
        "总票数": "Total number pkgs",
        "总签收票数": "Total number pkgs signed",
        "总签收率": "Total signing rate",
        "未完成票数": "Unfinished quantity",
        "未完成占比": "Unfinished proportion",
        "失败票数": "Failed pkgs",
        "失败占比": "Failed proportion",
        "平均签收时间": "Average signed time",
        "最小签收时间": "Min signed time",
        "最大签收时间": "Max signed time",
        "平均上线时间": "Average online time",
        "平均首次派送时间": "Average first delivery time",
        "≤H3D 占比": "≤H3D Proportion",
        "≤H4D 占比": "≤H4D Proportion",
        "≤H5D 占比": "≤H5D Proportion",
        "≤H6D 占比": "≤H6D Proportion",
        "≤H7D 占比": "≤H7D Proportion",
        "≤H8D 占比": "≤H8D Proportion",
        "≤H9D 占比": "≤H9D Proportion",
        "≤H10D 占比": "≤H10D Proportion",
        "≤H11D 占比": "≤H11D Proportion",
        "≤H12D 占比": "≤H12D Proportion",
        "≤H13D 占比": "≤H13D Proportion",
        "请选择": "Select"
    },
    "pages": {
        "bas": {
            "sorting": {
                "sorting": {
                    "修改": "",
                    "分拣码信息": "",
                    "优先级": "",
                    "分拣码": "",
                    "名称": "",
                    "走货路线": "",
                    "分拣规则": "",
                    "指定路线": "",
                    "客户": "",
                    "保存": "",
                    "关闭": "",
                    "国家简码": "",
                    "货物类型": "",
                    "分拣分区": "",
                    "报关方式": "",
                    "收费重范围": "",
                    "申报价值范围": "",
                    "COD金额范围": "",
                    "拦截": "",
                    "启用": "",
                },
            },
            "zipdestinationstrategy": {
                "zipdestinationstrategy": {
                    "增加": "",
                    "修改": "",
                    "删除": "",
                    "新增": "",
                    "导出": "",
                    "目的地策略": "",
                    "邮编分类": "",
                    "国家简码": "",
                    "邮编": "",
                    "目的地": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "邮编目的地策略": "",
                    "分拣码信息": "",
                    "优先级": "",
                    "分拣码": "",
                    "名称": "",
                    "走货路线": "",
                    "分拣规则": "",
                    "指定路线": "",
                    "客户": "",
                    "货物类型": "",
                    "分拣分区": "",
                    "报关方式": "",
                    "收费重范围": "",
                    "申报价值范围": "",
                    "COD金额范围": "",
                    "拦截": "",
                    "启用": "",
                    "国家": "",
                    "邮编目的地分类": "",
                    "起始邮编": "",
                    "终止邮编": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "分类编码": "",
                    "分类名称": "",
                    "排列顺序": "",
                    "新增邮编目的地策略": "",
                    "新增邮编目的地分类": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请输入": "",
                    "是否删除当前邮编目的地分类?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "删除成功！": "",
                    "请选择一行数据": "",
                    "是否删除该邮编目的地策略": "",
                    "删除异常": "",
                    "起始邮编只允许填入数值、大写字母": "",
                    "终止邮编只允许填入数值、大写字母": "",
                    "终止邮编长度必须与起始邮编长度一致": "",
                    "添加异常": "",
                    "添加成功！": "",
                    "修改异常": "",
                    "修改成功！": "",
                    "修改邮编目的地策略": "",
                    "修改邮编目的地分类": "",
                    "内容有修改,是否确认关闭？": "",

                }
            },
            "productcontrolrules": {
                "productcontrolrules": {
                    "导入": "",
                    "删除": "",
                    "导出": "",
                    "品名对照规则": "",
                    "英文品名": "",
                    "中文品名": "",
                    "查询": "",
                    "重置": "",
                    "备注": "",
                    "创建人": "",
                    "创建时间": "",
                    "修改人": "",
                    "修改时间": "",
                    "确定要删除吗？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "请选择一行数据": "",
                    "删除异常": "",
                    "删除成功！": "",
                    "接口对接INVOICE时如中文品名为空，需自动根据英文品名转换为中文品名": "",
                    "匹配英文品名，得到中文品名;被选中的记录需符合以下条件，以分号分隔的字符串需包含在INVOICE的英文品名中（不分先后顺序），优先于完全匹配": "",
                },
                "productnameimport": {
                    "导入模版": "",
                    "模版下载": "",
                    "导入": "",
                    "批次号": "",
                    "导入文件": "",
                    "导入时间": "",
                    "状态": "",
                    "总行数": "",
                    "错误行数": "",
                    "文件下载": "",
                    "历史日志": "",
                    "导入历史日志": "",
                    "请输入": "",
                    "行号": "",
                    "英文品名": "",
                    "错误说明": "",
                    "请选择模版！": "",
                    "请选择导入模版！": "",
                    "导入文件不能超过10MB": "",
                    "解析中": "",
                    "失败": "",
                    "导入中": "",
                    "上传中": "",
                    "上传失败": "",
                    "解析失败": "",
                    "验证中": "",
                    "验证失败": "",
                    "成功": "",
                    "订单导入成功": "",
                    "导入成功才可下载": ""
                }
            },
            "descrmanage": {
                "descrmanage": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "导出": "",
                    "品名信息": "",
                    "中文品名": "",
                    "英文品名": "",
                    "海关编码": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基础信息": "",
                    "启用": "",
                    "税率": "",
                    "品牌": "",
                    "材质": "",
                    "用途": "",
                    "规格": "",
                    "备注": "",
                    "保存": "",
                    "关闭": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请输入": "",
                    "新增品名": "",
                    "修改品名": "",
                    "请选择品名": "",
                    "新增成功": "",
                    "修改成功": "",
                    "此操作将删除该品名, 是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "删除成功": "",
                    "内容有修改,是否确认关闭？": "",
                }
            },
            "customerconnection": {
                "customerconnection": {
                    "启用订单": "",
                    "保存并继续": "",
                    "在收货时会根据实际收货的重量与材积验证排货准确性": "",
                    "新增客户对接授权": "",
                    "全部": "",
                    "按关键字检索": "",
                    "打单指定路线": "",
                    "指定路线": "",
                    "保存": "",
                    "排货走货路线": "",
                    "密钥": "",
                    "请选择客户": "",
                    "已启用订单授权": "",
                    "已选客户列表": "",
                    "订单授权开放指定路线": "",
                    "已启用授权": "",
                    "固定走货路线": "",
                    "打单授权操作": "",
                    "会自动产生问题件": "",
                    "注意": "",
                    "帐户": "",
                    "打印前置使用": "",
                    "所属网点": "",
                    "已启用打单授权": "",
                    "未启用授权": "",
                    "订单授权操作": "",
                    "客户名称": "",
                    "新增授权": "",
                    "启用订单授权": "",
                    "打单重量小于收费重": "",
                    "启用打单授权": "",
                    "停用": "",
                    "授权成功！": "",
                    "走货路线": "",
                    "启用订单授权与启用打单授权必勾其一": "",
                    "停用授权": "",
                    "由系统按排货策略选取走货路线后再打单": "",
                    "打单走货路线规则": "",
                    "关闭": "",
                    "订单授权": "",
                    "启用": "",
                    "收货时验证排货": "",
                    "打单成功！": "",
                    "客户": "",
                    "当打单走货路线规则": "",
                    "可设置走货路线": "",
                    "客户列表": "",
                    "停用打单": "",
                    "客户接口授权": "",
                    "客户编码": "",
                    "启用客户": "",
                    "对接设置": "",
                    "勾选后": "",
                    "打单授权": "",
                    "停用订单": "",
                    "启用打单": "",
                    "时且勾选收货时验证排货": "",
                    "订单成功！": "",
                    "时": "",
                    "排货前置和": "",
                    "待选指定路线": "",
                    "此设置用于": "",
                    "表示客户对应指定路线按走货路线成本价格进行结算": "",
                    "客户编码/客户名称": ""
                },
                "dockingset": {
                    "回调地址": "",
                    "关闭": "",
                    "保存对接设置成功": "",
                    "请输入": "",
                    "注册": "",
                    "API名称": "",
                    "保存对接设置异常": "",
                    "对接设置": "",
                    "备注": "",
                    "接口参数 <": "",
                    "生成回调地址": "",
                    "API编码": ""
                },
            },
            "tracknorule": {
                "trackNoRule": {
                    "修改": "",
                    "示例单号": "",
                    "规则": "",
                    "可用份数": "",
                    "规则名称": "",
                    "起始单号不符合单号规则": "",
                    "删除": "",
                    "指定路线": "",
                    "查询": "",
                    "关闭": "",
                    "保存": "",
                    "重置": "",
                    "启用": "",
                    "请生成": "",
                    "修改时间": "",
                    "可多选": "",
                    "请选择一行数据": "",
                    "创建人": "",
                    "预警份数": "",
                    "修改异常": "",
                    "起始单号": "",
                    "请先输入单号规则": "",
                    "新增17单号规则": "",
                    "新增": "",
                    "确定": "",
                    "规则编码": "",
                    "终止单号": "",
                    "请先输入起始单号或终止单号": "",
                    "提示": "",
                    "内容有修改,是否确认关闭？": "",
                    "删除成功！": "",
                    "启用状态": "",
                    "修改17单号规则": "",
                    "删除异常": "",
                    "添加成功！": "",
                    "确定删除吗？": "",
                    "请输入": "",
                    "正在使用中，请谨慎操作。确定删除吗？": "",
                    "修改人": "",
                    "取消": "",
                    "创建时间": "",
                    "单号规则": "",
                    "终止单号不符合单号规则": "",
                    "添加异常": "",
                    "生成示例单号": "",
                    "总份数": "",
                    "修改成功！": ""
                }
            },
            "inventorystrategy": {
                "inventorystrategy": {
                    "排货策略": "",
                    "修改": "",
                    "如": "",
                    "保存并继续": "",
                    "英文目的地": "",
                    "终止邮编": "",
                    "收件邮编格式": "",
                    "修改成功": "",
                    "名称": "",
                    "指定路线启用": "",
                    "指定路线": "",
                    "查询": "",
                    "选择": "",
                    "保存": "",
                    "邮编只能包含数字、逗号和“-”": "",
                    "调用表配置加载失败，请联系管理员！": "",
                    "收件邮编": "",
                    "创建人": "",
                    "指定路线比价排货": "",
                    "多组用回车或逗号隔开": "",
                    "限制货物类型": "",
                    "请选择排货策略": "",
                    "请选择数据": "",
                    "多选": "",
                    "新增排货策略": "",
                    "编码": "",
                    "此操作将删除该排货策略, 是否继续?": "",
                    "请选择": "",
                    "修改排货策略": "",
                    "选择客户": "",
                    "所属网点": "",
                    "修改人": "",
                    "不含目的地服务限制中的货物类型": "",
                    "客户名称": "",
                    "序号": "",
                    "删除成功": "",
                    "走货路线": "",
                    "删除": "",
                    "关闭": "",
                    "重置": "",
                    "刷新": "",
                    "简体目的地": "",
                    "目的地": "",
                    "修改时间": "",
                    "目的地和邮编只能填写其一": "",
                    "单选": "",
                    "新增": "",
                    "确定": "",
                    "目的地编码": "",
                    "提示": "",
                    "内容有修改,是否确认关闭？": "",
                    "客户编码": "",
                    "起始邮编": "",
                    "起始与终止长度一致": "",
                    "新增成功": "",
                    "限定货物类型": "",
                    "导出": "",
                    "取消": "",
                    "创建时间": "",
                    "选取": ""
                }
            },
            "sortingstrategy": {
                "sortingstrategy": {
                    "请选择分拣策略": "",
                    "修改": "",
                    "保存并继续": "",
                    "英文目的地": "",
                    "分拣码": "",
                    "新增分拣策略": "",
                    "请输入分拣卡口或分拣码！": "",
                    "报关类型": "",
                    "删除成功": "",
                    "修改成功": "",
                    "走货路线": "",
                    "请输入目的地、报关方式或货物类型！": "",
                    "删除": "",
                    "请输入客户或走货路线！": "",
                    "查询": "",
                    "关闭": "",
                    "保存": "",
                    "重置": "",
                    "启用": "",
                    "简体目的地": "",
                    "目的地": "",
                    "修改时间": "",
                    "修改分拣策略": "",
                    "创建人": "",
                    "客户": "",
                    "新增": "",
                    "确定": "",
                    "目的地编码": "",
                    "多选": "",
                    "内容有修改,是否确认关闭？": "",
                    "提示": "",
                    "分拣策略": "",
                    "请选择": "",
                    "此操作将删除该分拣策略, 是否继续?": "",
                    "启用状态": "",
                    "新增成功": "",
                    "报关方式": "",
                    "所属网点": "",
                    "货物类型": "",
                    "导出": "",
                    "修改人": "",
                    "取消": "",
                    "分拣卡口": "",
                    "创建时间": "",
                    "走货路线必填其一": ""
                }
            },
            "baggingStrategy": {
                "baggingStrategy": {
                    "修改": "",
                    "规则中只能存在一段流水号规则": "",
                    "保存并继续": "",
                    "英文目的地": "",
                    "邮包互换局": "",
                    "修改成功": "",
                    "请选择共享网点": "",
                    "目的地机场代码": "",
                    "装包策略": "",
                    "查询": "",
                    "保存": "",
                    "单票限制价值": "",
                    "支持，,；;、多种符号(可含回车)分隔，如中国、香港或中国；美国": "",
                    "最小单票限制申报价值不能大于最大单票限制申报价值": "",
                    "可多选": "",
                    "创建人": "",
                    "规则第五段不能为空": "",
                    "自动包号": "",
                    "共享给指定": "",
                    "多选": "",
                    "请选择": "",
                    "注意": "",
                    "启用状态": "",
                    "为保证包号严谨性": "",
                    "此操作将删除该装包策略, 是否继续?": "",
                    "所属网点": "",
                    "修改人": "",
                    "整包限制重量": "",
                    "策略名称": "",
                    "删除成功": "",
                    "走货路线": "",
                    "备注": "",
                    "删除": "",
                    "关闭": "",
                    "规则第三段不能为空": "",
                    "重置": "",
                    "启用": "",
                    "简体目的地": "",
                    "自动生成包号规则": "",
                    "目的地": "",
                    "修改时间": "",
                    "单票限制申报价值": "",
                    "共享网点": "",
                    "修改装包策略": "",
                    "派件网点": "",
                    "最小整包限制重量不能大于最大整包限制重量": "",
                    "新增": "",
                    "确定": "",
                    "策略编码": "",
                    "目的地编码": "",
                    "规则第三段和第五段必填": "",
                    "内容有修改,是否确认关闭？": "",
                    "提示": "",
                    "共享方式": "",
                    "新增装包策略": "",
                    "新增成功": "",
                    "限定货物类型": "",
                    "报关方式": "",
                    "邮局互换局": "",
                    "货物类型": "",
                    "导出": "",
                    "请输入": "",
                    "取消": "",
                    "创建时间": "",
                    "请选择装包策略": ""
                }
            },
            "ordervalidationrules": {
                "ordervalidationrules": {
                    "确定要删除吗？": "",
                    "修改": "",
                    "保存并继续": "",
                    "示例单号": "",
                    "有效起始位置必须有值且大于0": "",
                    "优先级": "",
                    "有效字符长度必须有值且大于0": "",
                    "规则名称": "",
                    "单号规则设置说明": "",
                    "示例单号不符合单号规则": "",
                    "删除": "",
                    "示例单号不能为空": "",
                    "查询": "",
                    "关闭": "",
                    "保存": "",
                    "示例有效单号": "",
                    "重置": "",
                    "启用": "",
                    "验证规则": "",
                    "修改时间": "",
                    "可多选": "",
                    "请选择一行数据": "",
                    "有效起始位置或有效字符长度与单号规则不符": "",
                    "创建人": "",
                    "修改异常": "",
                    "单号类型": "",
                    "新增": "",
                    "确定": "",
                    "提示": "",
                    "修改单号验证规则": "",
                    "内容有修改,是否确认关闭？": "",
                    "测试": "",
                    "删除成功！": "",
                    "新增单号验证规则": "",
                    "启用状态": "",
                    "删除异常": "",
                    "添加成功！": "",
                    "规则排序": "",
                    "有效字符长度": "",
                    "请输入": "",
                    "修改人": "",
                    "&不能混合其他字符一起使用": "",
                    "取消": "",
                    "创建时间": "",
                    "单号规则": "",
                    "添加异常": "",
                    "有效起始位置": "",
                    "修改成功！": "",
                    "原始单号AB1234567890，可设置规则为##**********；存在固定字母或数字，可设置#或*为具体字母或数字，如AB8*********；": "",
                    "假设运单总长度10位，数字+字母且不确定字母位置，可设置规则&&&&&&&&&&；": "",
                    "&符号不能与#或者*混用。": "",
                    "%表示包含，不限制%前单号位数，此时不能做截取": "",
                }
            },


            "dest": {
                "destmag": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "设置报音": "",
                    "导出": "",
                    "目的地信息": "",
                    "目的地编码": "",
                    "目的地名称": "",
                    "国家简码": "",
                    "英文名称": "",
                    "国家别名": "",
                    "业务类型": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基础信息": "",
                    "启用": "",
                    "目的地国币别": "",
                    "目的地服务电话": "",
                    "可多选": "",
                    "多个别名": "",
                    "请用": "",
                    "或": "",
                    "隔开": "",
                    "主要用报价分区导入": "",
                    "中文名称": "",
                    "备注": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "报音文件": "",
                    "序号": "",
                    "货物类型": "",
                    "请输入": "",
                    "请选择": "",
                    "目的地国家币别": "",
                    "目的地国服务电话": "",
                    "目的地报音": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "新增目的地": "",
                    "修改目的地": "",
                    "请选择目的地": "",
                    "新增成功": "",
                    "修改成功": "",
                    "此操作将删除该目的地, 是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "删除成功": "",
                    "目的地": "",
                    "内容有修改,是否确认关闭？": "",
                    "目的地设置报音": "",
                    "报音文件不能为空，请重新选择！": "",
                }
            },
            "agentmanagement": {
                "agentmanagement": {
                    "新增": "",
                    "修改": "",
                    "批量修改": "",
                    "浏览": "",
                    "删除": "",
                    "导出": "",
                    "代理信息": "",
                    "所属网点": "",
                    "代理编码": "",
                    "代理名称": "",
                    "代理类型": "",
                    "启用状态": "",
                    "对账员": "",
                    "查询": "",
                    "重置": "",
                    "基础信息": "",
                    "启用": "",
                    "代理简码": "",
                    "代理全称": "",
                    "英文名称": "",
                    "所属国家": "",
                    "所属州": "",
                    "省": "",
                    "所属城市": "",
                    "所属邮编": "",
                    "地址": "",
                    "地址2": "",
                    "备注": "",
                    "付款信息": "",
                    "付款账号信息": "",
                    "银行账号": "",
                    "开户银行": "",
                    "开户人": "",
                    "付款账号协议": "",
                    "只能上传": "",
                    "张": "",
                    "格式": "",
                    "图片文件": "",
                    "不超过": "",
                    "联络信息": "",
                    "序号": "",
                    "操作": "",
                    "联系人": "",
                    "岗位": "",
                    "电话": "",
                    "手机": "",
                    "传真": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "修改信息": "",
                    "当前选择批量修改代理": "",
                    "家": "",
                    "请谨慎修改": "",
                    "新增代理": "",
                    "所属州/省": "",
                    "最后一次交货时间": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请输入": "",
                    "内容有修改,是否确认关闭？": "",
                    "是否删除当前代理": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "请选择一行数据": "",
                    "删除异常": "",
                    "删除成功！": "",
                    "请输入代理编码": "",
                    "不能存在相同联系人": "",
                    "添加异常": "",
                    "添加成功！": "",
                    "修改异常": "",
                    "修改成功！": "",
                    "请选择要修改的数据": "",
                    "请选择代理类型": "",
                    "请选择对账员": "",
                    "请先选择要修改列": "",
                    "代理浏览": "",
                    "获取文件路径异常": "",
                    "修改代理": "",
                    "代理管理": "",
                    "文件大小不能大于2MB": "",
                    "只能上传jpeg/jpg/png文件": "",
                    "确定删除此行吗？": "",
                    "联系人不能为空": "",
                    "岗位不能为空": "",
                    "手机不能为空": "",
                }
            },
            "cust": {
                "custSetting": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "共享": "",
                    "不共享": "",
                    "共享给所有": "",
                    "共享给指定": "",
                    "导出": "",
                    "客户分组信息": "",
                    "客户组编码": "",
                    "客户组名称": "",
                    "所属网点": "",
                    "共享方式": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基本信息": "",
                    "启用": "",
                    "中隐藏公式": "",
                    "备注": "",
                    "共享网点": "",
                    "可多选": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "共享给指定网点": "",
                    "网点列表": "",
                    "指定网点": "",
                    "请输入关键字": "",
                    "新增客户组": "",
                    "VIP中隐藏公式": "",
                    "建立时间": "",
                    "建立人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请输入": "",
                    "确定要删除吗？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "请选择一行数据": "",
                    "删除异常": "",
                    "删除成功！": "",
                    "添加异常": "",
                    "添加成功！": "",
                    "修改异常": "",
                    "修改成功！": "",
                    "至少选择一个网点！": "",
                    "保存异常": "",
                    "修改共享方式成功！": "",
                    "修改共享方式失败！": "",
                    "修改客户组": "",
                    "浏览客户组": "",
                    "客户组管理": "",
                    "内容有修改,是否确认关闭？": "",
                },
                "custmag": {
                    "客户委托指定": "",
                    "删除销售员配置成功！": "",
                    "只显示含附件": "",
                    "交易流水": "",
                    "客户编号": "",
                    "部门": "",
                    "行,缺少联系人": "",
                    "请选择客户": "",
                    "自动发送账单邮件": "",
                    "获取文件路径异常": "",
                    "此操作将停用该客户, 是否继续?": "",
                    "操作": "",
                    "子客户目的国家简码": "",
                    "禁用下载": "",
                    "关联主客户": "",
                    "请填写\"\"基本信息\"\"！": "",
                    "主客户编码不能为空": "",
                    "请选择客户状态": "",
                    "回款期限": "",
                    "所属网点": "",
                    "自动触发账单发送到指定邮箱": "",
                    "修改人": "",
                    "客户名称": "",
                    "通知人优先取值客户管理": "",
                    "默认帐单格式": "",
                    "账单发送邮箱": "",
                    "停用": "",
                    "是否需开票": "",
                    "请填写必填值！": "",
                    "营业执照号": "",
                    "英文地址": "",
                    "请选择港前客服": "",
                    "删除": "",
                    "请选择销售员": "",
                    "允许有多个网点": "",
                    "浏览": "",
                    "结算周期": "",
                    "当前客户停用失败！": "",
                    "当前结算周期在第几天开始计算回款期限": "",
                    "关联客户组为空，确定继续保存吗？": "",
                    "客户编码": "",
                    "主客户编码": "",
                    "请选择\"所属网点\"!": "",
                    "此操作将删除该联系人, 是否继续?": "",
                    "中客户下单时": "",
                    "帐单接收邮箱最多可以输入5个": "",
                    "请输入": "",
                    "取消": "",
                    "客户修改成功": "",
                    "最多可以输入": "",
                    "保存并继续": "",
                    "绑定子客户": "",
                    "客户状态": "",
                    "最后交货时间": "",
                    "查询": "",
                    "业务手机": "",
                    "港前指定处理岗位": "",
                    "请选择先客户！": "",
                    "帐单接收邮箱缺少“@”字符": "",
                    "个邮箱缺少“@”字符": "",
                    "结算日为": "",
                    "结算账单": "",
                    "所属城市": "",
                    "该模式将优先调用寄件人对接人跟进": "",
                    "如果结算周期是周结": "",
                    "客户联系人": "",
                    "税金押金币别": "",
                    "请选择\"客户类型\"!": "",
                    "登记港前": "",
                    "港后指定处理岗位对应的员工": "",
                    "根据主客户编码": "",
                    "账单审核后": "",
                    "同行客户": "",
                    "多个邮箱之间用": "",
                    "结算日": "",
                    "举例说明": "",
                    "请输入\"客户编码\"!": "",
                    "通知岗位": "",
                    "此客户只允许所属网点录单": "",
                    "请选择\"客户状态\"!": "",
                    "帐单信息": "",
                    "当前选择批量修改客户": "",
                    "当前为主客户": "",
                    "修改成功！": "",
                    "运费押金": "",
                    "对账员": "",
                    "财务联络人": "",
                    "请选择客户类型": "",
                    "请填写\"基本信息\"！": "",
                    "签约日期": "",
                    "备注": "",
                    "复制新增": "",
                    "个文件": "",
                    "关闭": "",
                    "所属邮编": "",
                    "关联客户组": "",
                    "请选择帐单发送邮箱": "",
                    "请选择港后客服": "",
                    "修改时间": "",
                    "按寄件人跟进": "",
                    "请输入\"客户名称\"!": "",
                    "请选择一行数据": "",
                    "合同编号": "",
                    "内部对接人信息": "",
                    "附件信息": "",
                    "新增": "",
                    "确定": "",
                    "用于订单导入时": "",
                    "客户委托所有": "",
                    "通知岗位对应的员工": "",
                    "文件大小不能大于10M": "",
                    "批量修改": "",
                    "无需关联": "",
                    "以其他客户为主客户": "",
                    "当前客户删除成功": "",
                    "税金押金": "",
                    "委托录单": "",
                    "港后客服": "",
                    "其他信息": "",
                    "所属国家": "",
                    "所属州": "",
                    "修改客户": "",
                    "指定处理岗位对应的员工": "",
                    "隔开": "",
                    "请选择\"运费押金币别\"!": "",
                    "修改": "",
                    "省": "",
                    "网点委托指定给": "",
                    "如有多个委托录单网点时": "",
                    "所属网点下的所有客户的录单委托给指定网点": "",
                    "请输入关键字": "",
                    "押金信息": "",
                    "保存": "",
                    "客户曾用名": "",
                    "联络": "",
                    "可多选": "",
                    "帐单接收邮箱第": "",
                    "创建人": "",
                    "复制新增客户": "",
                    "请输入帐单接收邮箱": "",
                    "附件": "",
                    "客户类型": "",
                    "修改信息": "",
                    "公司中文名称": "",
                    "请选择对账员": "",
                    "行邮箱地址缺少“@”字符": "",
                    "勾选客户委托指定时，必须选择委托录单网点！": "",
                    "网点列表": "",
                    "在": "",
                    "天": "",
                    "注意": "",
                    "付款方式": "",
                    "基本信息": "",
                    "第": "",
                    "当前客户已被停用": "",
                    "浏览客户": "",
                    "客户等级": "",
                    "对接信息": "",
                    "请添加联系信息": "",
                    "请选择\"结算周期\"！": "",
                    "取件员": "",
                    "首次交货时间": "",
                    "指定处理人优先取值客户管理": "",
                    "客户管理": "",
                    "按客户跟进": "",
                    "发票公司抬头": "",
                    "跟进模式": "",
                    "帐单": "",
                    "发票信息": "",
                    "重置": "",
                    "此客户的录单委托给指定网点": "",
                    "表示下周二开始计算回款期限": "",
                    "第一个为默认的录单网点": "",
                    "当前客户删除失败！": "",
                    "个邮箱": "",
                    "请先选择要修改列": "",
                    "添加或者修改销售员，系统会根据时间排序并把下一个起始时间作为上一个时间的终止时间，确定继续保存吗？": "",
                    "子客户目的国家简码自动分拣出子客户编码": "",
                    "请填写销售员": "",
                    "港后指定处理岗位": "",
                    "收件人管理": "",
                    "提示": "",
                    "账单接收邮箱": "",
                    "委托录单网点列表": "",
                    "导出": "",
                    "财务联络电话": "",
                    "自结算日开始多少天内回款": "",
                    "港前客服": "",
                    "基础信息": "",
                    "联系人": "",
                    "自动生成账单": "",
                    "业务电话": "",
                    "邮箱地址": "",
                    "请选择\"税金押金币别\"!": "",
                    "中文地址": "",
                    "身份证号": "",
                    "请选择\"客户分类\"！": "",
                    "运费押金币别": "",
                    "请谨慎修改": "",
                    "起始日期": "",
                    "新增客户成功": "",
                    "税号": "",
                    "家": "",
                    "其次取值问题状态": "",
                    "可用于子客户分拣和统一以主客户收款": "",
                    "请选择所属网点": "",
                    "正在上传水单，请稍等": "",
                    "发票": "",
                    "此客户委托给任意网点录单": "",
                    "文件格式": "",
                    "逾期利率": "",
                    "当前客户即为主客户": "",
                    "请选择跟单员": "",
                    "是否签合同": "",
                    "客户不委托": "",
                    "增加": "",
                    "合同信息": "",
                    "网点未委托": "",
                    "当前联系人删除成功": "",
                    "请选择默认帐单格式": "",
                    "新增客户": "",
                    "销售员": "",
                    "请填写起始时间": "",
                    "网站限制查件": "",
                    "港后问题件时": "",
                    "最多上传": "",
                    "跟单员": "",
                    "单文件不超过": "",
                    "内容有修改,是否确认关闭？": "",
                    "客户分类": "",
                    "超过回款期限开始计算逾期": "",
                    "不限": "",
                    "发票地址": "",
                    "请先关联客户组！": "",
                    "公司英文名称": "",
                    "客户附件": "",
                    "港前": "",
                    "传真": "",
                    "此操作将删除该客户, 是否继续?": "",
                    "目的国家简码": "",
                    "创建时间": "",
                    "请先选择客户": ""
                }
            },
            "sender": {
                "sender": {
                    "新增": "",
                    "修改": "",
                    "批量修改": "",
                    "删除": "",
                    "导出": "",
                    "寄件人管理": "",
                    "寄件公司": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "所属网点": "",
                    "分类标签": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基本信息": "",
                    "基础信息": "",
                    "启用": "",
                    "所属客户": "",
                    "寄件公司别名": "",
                    "多个别名请用": "",
                    "分割": "",
                    "地址信息": "",
                    "寄件地址": "",
                    "寄件邮箱": "",
                    "寄件国家": "",
                    "寄件州": "",
                    "省": "",
                    "寄件城市": "",
                    "寄件邮编": "",
                    "联络&对接信息": "",
                    "寄件人联系人": "",
                    "操作": "",
                    "增加": "",
                    "联系人": "",
                    "部门": "",
                    "业务电话": "",
                    "业务手机": "",
                    "传真": "",
                    "邮箱地址": "",
                    "备注": "",
                    "内部对接人信息": "",
                    "销售员": "",
                    "跟单员": "",
                    "港前客服": "",
                    "港后客服": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "修改信息": "",
                    "当前选择批量修改寄件人": "",
                    "家": "",
                    "请谨慎修改": "",
                    "请输入": "",
                    "寄件地址2": "",
                    "寄件地址3": "",
                    "寄件州/省": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "修改成功！": "",
                    "此联系人将被删除，确认继续吗？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "请选择单行数据": "",
                    "确定要删除吗？": "",
                    "请选择一行数据": "",
                    "删除异常": "",
                    "删除成功！": "",
                    "寄件公司不能为空": "",
                    "寄件人不能为空": "",
                    "寄件电话不能为空": "",
                    "寄件邮编不能为空": "",
                    "添加异常": "",
                    "添加成功！": "",
                    "修改异常": "",
                    "请选择至少一行数据！": "",
                    "新增寄件人管理": "",
                    "修改寄件人管理": "",
                    "内容有修改,是否确认关闭？": "",
                }
            },
            "recipient": {
                "recipient": {
                    "新增": "",
                    "修改": "",
                    "批量修改": "",
                    "删除": "",
                    "导出": "",
                    "寄件人管理": "",
                    "寄件公司": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "所属网点": "",
                    "分类标签": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基本信息": "",
                    "基础信息": "",
                    "启用": "",
                    "所属客户": "",
                    "寄件公司别名": "",
                    "多个别名请用": "",
                    "分割": "",
                    "地址信息": "",
                    "寄件地址": "",
                    "寄件邮箱": "",
                    "寄件国家": "",
                    "寄件州": "",
                    "省": "",
                    "寄件城市": "",
                    "寄件邮编": "",
                    "联络&对接信息": "",
                    "寄件人联系人": "",
                    "操作": "",
                    "增加": "",
                    "联系人": "",
                    "部门": "",
                    "业务电话": "",
                    "业务手机": "",
                    "传真": "",
                    "邮箱地址": "",
                    "备注": "",
                    "内部对接人信息": "",
                    "销售员": "",
                    "跟单员": "",
                    "港前客服": "",
                    "港后客服": "",
                    "保存并继续": "",
                    "保存": "",
                }
            },
            "goodsalloc": {
                "goodsalloc": {
                    "新增": "",
                    "修改": "",
                    "批量修改": "",
                    "删除": "",
                    "导出": "",
                    "寄件人管理": "",
                    "寄件公司": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "所属网点": "",
                    "分类标签": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基本信息": "",
                    "基础信息": "",
                    "启用": "",
                    "所属客户": "",
                    "寄件公司别名": "",
                    "多个别名请用": "",
                    "分割": "",
                    "地址信息": "",
                    "寄件地址": "",
                    "寄件邮箱": "",
                    "寄件国家": "",
                    "寄件州": "",
                    "省": "",
                    "寄件城市": "",
                    "寄件邮编": "",
                    "联络&对接信息": "",
                    "寄件人联系人": "",
                    "操作": "",
                    "增加": "",
                    "联系人": "",
                    "部门": "",
                    "业务电话": "",
                    "业务手机": "",
                    "传真": "",
                    "邮箱地址": "",
                    "备注": "",
                    "内部对接人信息": "",
                    "销售员": "",
                }
            },
            "scan": {
                "scanMag": {
                    "新增": "",
                    "修改": "",
                    "批量修改": "",
                    "删除": "",
                    "导出": "",
                    "寄件人管理": "",
                    "寄件公司": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "所属网点": "",
                    "分类标签": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基本信息": "",
                    "基础信息": "",
                    "启用": "",
                    "所属客户": "",
                    "寄件公司别名": "",
                    "多个别名请用": "",
                    "分割": "",
                    "地址信息": "",
                    "寄件地址": "",
                    "寄件邮箱": "",
                    "寄件国家": "",
                    "寄件州": "",
                    "省": "",
                    "寄件城市": "",
                    "寄件邮编": "",
                    "联络&对接信息": "",
                    "寄件人联系人": "",
                    "操作": "",
                    "增加": "",
                    "联系人": "",
                    "部门": "",
                    "业务电话": "",
                    "业务手机": "",
                    "传真": "",
                    "邮箱地址": "",
                    "备注": "",
                    "内部对接人信息": "",
                    "销售员": "",
                    "跟单员": "",
                    "港前客服": "",
                    "港后客服": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "修改信息": "",
                    "当前选择批量修改寄件人": "",
                    "家": "",
                    "请谨慎修改": "",
                    "请输入": "",
                    "寄件地址2": "",
                    "寄件地址3": "",
                    "寄件州/省": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                }
            },
            "problemstatus": {
                "problemstatus": {
                    "新增": "",
                    "修改": "",
                    "批量修改": "",
                    "删除": "",
                    "导出": "",
                    "寄件人管理": "",
                    "寄件公司": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "所属网点": "",
                    "分类标签": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基本信息": "",
                    "基础信息": "",
                    "启用": "",
                    "所属客户": "",
                    "寄件公司别名": "",
                    "多个别名请用": "",
                    "分割": "",
                    "地址信息": "",
                    "寄件地址": "",
                    "寄件邮箱": "",
                    "寄件国家": "",
                    "寄件州": "",
                    "省": "",
                    "寄件城市": "",
                    "寄件邮编": "",
                    "联络&对接信息": "",
                    "寄件人联系人": "",
                    "操作": "",
                    "增加": "",
                    "联系人": "",
                    "部门": "",
                    "业务电话": "",
                    "业务手机": "",
                    "传真": "",
                    "邮箱地址": "",
                    "备注": "",
                    "内部对接人信息": "",
                    "销售员": "",
                    "跟单员": "",
                    "港前客服": "",
                    "港后客服": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "修改信息": "",
                    "当前选择批量修改寄件人": "",
                    "家": "",
                    "请谨慎修改": "",
                    "请输入": "",
                    "寄件地址2": "",
                    "寄件地址3": "",
                    "寄件州/省": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "修改成功！": "",
                    "此联系人将被删除，确认继续吗？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "请选择单行数据": "",
                    "确定要删除吗？": "",
                    "请选择一行数据": "",
                    "删除异常": "",
                    "删除成功！": "",
                    "寄件公司不能为空": "",
                    "寄件人不能为空": "",
                    "寄件电话不能为空": "",
                    "寄件邮编不能为空": "",
                    "添加异常": "",
                    "添加成功！": "",
                    "修改异常": "",
                }
            },
            "arded": {
                "ardedmag": {
                    "新增": "",
                    "修改": "",
                    "批量修改": "",
                    "删除": "",
                    "导出": "",
                    "寄件人管理": "",
                    "寄件公司": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "所属网点": "",
                    "分类标签": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基本信息": "",
                    "基础信息": "",
                    "启用": "",
                    "所属客户": "",
                    "寄件公司别名": "",
                    "多个别名请用": "",
                    "分割": "",
                    "地址信息": "",
                    "寄件地址": "",
                    "寄件邮箱": "",
                    "寄件国家": "",
                    "寄件州": "",
                    "省": "",
                    "寄件城市": "",
                    "寄件邮编": "",
                    "联络&对接信息": "",
                    "寄件人联系人": "",
                    "操作": "",
                    "增加": "",
                    "联系人": "",
                    "部门": "",
                    "业务电话": "",
                    "业务手机": "",
                    "传真": "",
                    "邮箱地址": "",
                    "备注": "",
                    "内部对接人信息": "",
                    "销售员": "",
                    "跟单员": "",
                    "港前客服": "",
                },
                "acctarded": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "导出": "",
                    "资金账户": "",
                    "所属网点": "",
                    "资金账户编码": "",
                    "资金账户名称": "",
                    "开户人": "",
                    "账户分类": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基础信息": "",
                    "启用": "",
                    "账户币别": "",
                    "银行账号": "",
                    "开户银行": "",
                    "收款手续费比例": "",
                    "最低手续费": "",
                    "备注": "",
                    "共享网点": "",
                    "共享方式": "",
                    "可多选": "",
                    "说明": "",
                    "将资金账户共享给其他网点": "",
                    "共享网点可通过当前资金账户进行客户代收代付业务": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "银行账户": "",
                    "请输入": "",
                    "请选择": "",
                    "余额": "",
                    "收款手续费比例(%)": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "新增资金账户": "",
                    "修改资金账户": "",
                    "请选择资金账户": "",
                    "请选择共享网点": "",
                    "新增成功": "",
                    "修改成功": "",
                    "此操作将删除该资金账户, 是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "删除成功": "",
                    "内容有修改,是否确认关闭？": "",
                },
                "szarded": {
                    "增加": "",
                    "修改": "",
                    "删除": "",
                    "新增": "",
                    "科目编码": "",
                    "科目名称": "",
                    "一级分类": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基础信息": "",
                    "启用": "",
                    "二级分类": "",
                    "核销类型": "",
                    "备注": "",
                    "标准科目": "",
                    "收入类科目": "",
                    "允许在客户收款": "",
                    "充值": "",
                    "退款时录入": "",
                    "支出类科目": "",
                    "允许在代理付款时录入": "",
                    "费用类科目": "",
                    "允许在费用报销录入": "",
                    "非标准客户只能在会计科目中录入": "",
                    "核销科目": "",
                    "核销科目允许在客户收付款": "",
                    "代理付款环节核销应收账款": "",
                    "公共科目": "",
                    "公共科目允许在客户收款": "",
                    "代理付款": "",
                    "费用报销中使用": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "标准二级分类": "",
                    "二级分类编码": "",
                    "二级分类名称": "",
                    "建立时间": "",
                    "建立人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请输入": "",
                    "请输入科目编码": "",
                    "请输入科目名称": "",
                    "请选择一级分类": "",
                    "请选择二级分类": "",
                    "获取二级分类树异常": "",
                    "内容有修改,是否确认关闭？": "",
                    "新增二级分类": "",
                    "修改二级分类": "",
                    "确定要删除吗？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "删除成功！": "",
                    "新增成功": "",
                    "修改成功！": "",
                    "新增收支科目": "",
                    "标准科目不允许修改！": "",
                    "修改收支科目": "",
                    "请选择需要修改的数据": "",
                    "请选择核销类型！": "",
                    "标准科目不允许删除！": "",
                    "请选择需要删除的数据": "",
                }
            },
            "shopee": {
                "shopeeServiceCode": {
                    "Shopee Service Code": "Shopee Service Code",
                    "国家简码": "",
                    "分拣码": "",
                    "Service Code": "Service Code",
                    "P/T": "P/T",
                    "EC/SC": "EC/SC",
                    "LM": "LM",
                    "新增 Shopee Service Code": "",
                    "修改 Shopee Service Code": "",
                    "基本信息": "",
                    "注意": "",
                    "导出shopee daily report时，若分拣码未配置对应的service code，则整个导出任务失败": "",
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "导出": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基础信息": "",
                    "启用": "",
                    "备注": "",
                    "保存": "",
                    "关闭": "",
                    "全部": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请选择数据": "",
                    "新增成功": "",
                    "修改成功": "",
                    "此操作将删除当前选择数据, 是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "删除成功": "",
                    "内容有修改,是否确认关闭？": "",
                },
            },
            "invoice": {
                "invoiceformula": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "浏览": "",
                    "启用": "",
                    "停用": "",
                    "导出": "",
                    "账单公式": "",
                    "公式编码": "",
                    "收付方向": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基本信息": "",
                    "默认公式": "",
                    "自动审核": "",
                    "新增账单公式": "",
                    "结算对象": "",
                    "浏览账单公式": "",
                    "归属收支科目": "",
                    "描述": "",
                    "账单号码规则": "",
                    "段": "",
                    "账单中文抬头": "",
                    "账单英文抬头": "",
                    "科目公式": "",
                    "科目": "",
                    "可多选": "",
                    "账单号码规则说明": "",
                    "最多可由": "",
                    "段组成": "",
                    "第": "",
                    "段可以为网点简码": "",
                    "年": "",
                    "月": "",
                    "流水号连接而成": "",
                    "段为固定位": "",
                    "流水号是必须项": "",
                    "只允许一项": "",
                    "保存": "",
                    "关闭": "",
                    "客户": "",
                    "应收": "",
                    "请输入": "",
                    "请选择": "",
                    "+科目": "",
                    "-科目": "",
                    "最近被使用时间": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "修改账单公式": "",
                    "请选择账单公式": "",
                    "账单号码规则中必须有流水号": "",
                    "账单号码规则中流水号只允许一项": "",
                    ">这些科目已经删除，是否确认保存？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "新增成功！": "",
                    "修改成功！": "",
                    "新增成功": "",
                    "此操作将删除该账单公式, 是否继续?": "",
                    "删除成功": "",
                    "此操作将启用该账单公式, 是否继续?": "",
                    "请选择已停用的账单公式进行启用！": "",
                    "启用成功": "",
                    "此操作将停用该账单公式, 是否继续?": "",
                    "请选择已启用账单公式进行停用！": "",
                    "停用成功": "",
                    "内容有修改,是否确认关闭？": "",
                }
            },
            "curexch": {
                "curexchset": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "其他汇率": "",
                    "导出": "",
                    "汇率": "",
                    "所属网点": "",
                    "换算币别": "",
                    "启用状态": "",
                    "只显示最新汇率": "",
                    "查询": "",
                    "重置": "",
                    "基础信息": "",
                    "启用": "",
                    "共享方式": "",
                    "生效日期": "",
                    "选择日期": "",
                    "修改汇率": "",
                    "共享网点": "",
                    "原币别": "",
                    "换算汇率": "",
                    "网点本位币": "",
                    "注意": "",
                    "换算汇率为将原币别转换为网点本位币的汇率": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "请选择": "",
                    "请输入": "",
                    "原币种": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "新增汇率": "",
                    "请选择汇率": "",
                    "新增成功": "",
                    "修改成功": "",
                    "此操作将删除该汇率, 是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "删除成功": "",
                    "内容有修改,是否确认关闭？": "",
                }
            },
            "outboxsetup": {
                "outboxsetup": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "发件箱地址": "",
                    "邮箱类型": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "设置信息": "",
                    "启用": "",
                    "发件箱类型": "",
                    "可多选": "",
                    "服务器地址": "",
                    "服务器端口": "",
                    "邮件服务器协议": "",
                    "用户名": "",
                    "密码": "",
                    "发送间隔": "",
                    "秒": "",
                    "保存": "",
                    "关闭": "",
                    "新增发件箱": "",
                    "请输入发件箱地址": "",
                    "请选择发件箱类型": "",
                    "请输入服务器地址": "",
                    "请输入服务器端口": "",
                    "请选择邮件服务器协议": "",
                    "请输入用户名": "",
                    "请输入密码": "",
                    "请输入发送间隔(秒)": "",
                    "发送间隔(秒)": "",
                    "首次发送时间": "",
                    "使用次数": "",
                    "最后使用时间": "",
                    "创建人": "",
                    "创建时间": "",
                    "修改人": "",
                    "修改时间": "",
                    "发件箱地址中没有“@”字符": "",
                    "服务器端口必须大于0": "",
                    "发送间隔必须大于0": "",
                    "添加异常": "",
                    "添加成功！": "",
                    "修改异常": "",
                    "修改成功！": "",
                    "内容有修改,是否确认关闭？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "修改发件箱": "",
                    "是否确认删除当前选择数据？": "",
                    "删除成功！": "",
                }
            },
            "pay": {
                "payonline": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "支付公司": "",
                    "支付方式": "",
                    "支付产品编码": "",
                    "商户编码": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "基础信息": "",
                    "启用": "",
                    "支付公司用于区分支付类型的编码": "",
                    "客户编码": "",
                    "在支付公司注册的客户编码": "",
                    "资金账户": "",
                    "充值成功后": "",
                    "生成客户收款记录时填入的资金账户": "",
                    "手续费比例": "",
                    "最低手续费": "",
                    "直接从金额中扣除手续费": "",
                    "剩余金额作为客户的到账金额": "",
                    "充值时": "",
                    "充值金额": "",
                    "到账金额": "",
                    "充值描述": "",
                    "充值时的商品名称": "",
                    "备注": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "请输入": "",
                    "请选择": "",
                    "支付公司编码": "",
                    "描述": "",
                    "新增在线充值规则": "",
                    "修改在线充值规则": "",
                    "请选择一条数据": "",
                    "新增成功": "",
                    "修改成功": "",
                    "此操作将删除该在线充值规则, 是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "请选择在线充值规则": "",
                    "删除成功": "",
                    "内容有修改,是否确认关闭？": "",
                }
            }

        },


        "bms": {
            "quotepackingfee": {
                "quotepackingfeeotherexch": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "导出": "",
                    "其他汇率": "",
                    "换算币别": "",
                    "查询": "",
                    "重置": "",
                    "基础信息": "",
                    "生效日期": "",
                    "新增汇率": "",
                    "原币别": "",
                    "换算汇率": "",
                    "网点本位币": "",
                    "注意": "",
                    "换算汇率为将原币别转换为网点本位币的汇率": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "原币种": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请选择": "",
                    "请输入": "",
                    "修改汇率": "",
                    "请选择汇率": "",
                    "此操作将删除该汇率, 是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "删除成功": "",
                    "内容有修改,是否确认关闭？": "",
                    "新增成功": "",
                    "修改成功": "",
                }
            }
        },


        "tms": {
            "fdorder": {
                "fdorder": {
                    "保存": "",
                    "保存并审单": "",
                    "保存并打印面单": "",
                    "设置": "",
                    "运单号码": "",
                    "转单号码": "",
                    "参考号码": "",
                    "渠道": "",
                    "寄件信息": "",
                    "选择": "",
                    "保存寄件信息": "",
                    "指定路线": "",
                    "目的地": "",
                    "客户": "",
                    "寄件公司": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "寄件地址": "",
                    "货物信息": "",
                    "包装类型": "",
                    "报关方式": "",
                    "货物类型": "",
                    "件数": "",
                    "收费实重": "",
                    "收费材重": "",
                    "收费重": "",
                    "申报价值": "",
                    "中文品名": "",
                    "英文品名": "",
                    "数量": "",
                    "收件备注": "",
                    "选填": "",
                    "字符以内": "",
                    "取件员": "",
                    "寄件网点": "",
                    "寄件日期": "",
                    "收件信息": "",
                    "保存收件信息": "",
                    "收件电话": "",
                    "必填": "",
                    "收件公司": "",
                    "收件地址": "",
                    "收件人": "",
                    "收件税号": "",
                    "收件邮编": "",
                    "收件州": "",
                    "省": "",
                    "收件城市": "",
                    "收件国家": "",
                    "结算信息": "",
                    "付款方式": "",
                    "到付款": "",
                    "付款客户": "",
                    "客户代号": "",
                    "代收款": "",
                    "科目": "",
                    "金额": "",
                    "税金付款": "",
                    "结算备注": "",
                    "信息": "",
                    "导入": "",
                    "显示": "",
                    "序号": "",
                    "操作": "",
                    "添加": "",
                    "删除": "",
                    "单价": "",
                    "总价": "",
                    "单个重量": "",
                    "海关编码": "",
                    "更多信息": "",
                    "点击保存按钮后添加信息": "",
                    "配货信息": "",
                    "商品图片地址": "",
                    "商品链接地址": "",
                    "材质": "",
                    "用途": "",
                    "规格": "",
                    "行邮税号": "",
                    "品牌": "",
                    "原产地": "",
                    "确定": "",
                    "清空": "",
                    "上传附件": "",
                    "导入格式": "",
                    "行": "",
                    "列": "",
                    "导入前请将": "",
                    "信息复制到剪贴板即可": "",
                    "注意以下几点要求": "",
                    "格式为": "",
                    "列与列直接用": "",
                    "隔开": "",
                    "关闭": "",
                    "请输入内容": "",
                    "其他": "",
                    "选取": "",
                    "扫描规则": "",
                    "允许跨网点收货": "",
                    "保留上一票信息": "",
                    "子单生成规则": "",
                    "固定位": "",
                    "流水号位数": "",
                    "最大打印件数": "",
                    "输入任意内容可检索": "",
                    "运单信息": "",
                    "注意": "",
                    "以下录入的都为单件信息": "",
                    "单件进位规则": "",
                    "单票计抛规则": "",
                    "修改": "",
                    "单票进位规则": "",
                    "单件信息": "",
                    "新增": "",
                    "实重": "",
                    "长": "",
                    "宽": "",
                    "高": "",
                    "除以数": "",
                    "材重": "",
                    "最小重量": "",
                    "生效类型": "",
                    "包装项目": "",
                    "包装费": "",
                    "币别": "",
                    "包装说明": "",
                    "子单号码": "",
                    "同步复制实重": "",
                    "尺寸复制": "",
                    "全部清除": "",
                    "全部删除": "",
                    "导出": "",
                    "选择寄件信息": "",
                    "录单设置": "",
                    "选择常用收件人": "",
                    "INVOICE导入": "",
                    "运费": "",
                    "燃油费": "",
                    "报关费": "",
                    "产证费": "",
                    "保险费": "",
                    "其他费": "",
                    "请输入运单号码": "",
                    "请选择取件员": "",
                    "请选择寄件网点": "",
                    "请选择寄件日期": "",
                    "请输入指定路线": "",
                    "请输入目的地": "",
                    "请输入客户": "",
                    "请输入收件电话": "",
                    "请输入收件地址": "",
                    "请输入收件人": "",
                    "请选择包装类型": "",
                    "请选择报关方式": "",
                    "请选择货物类型": "",
                    "请输入件数": "",
                    "请输入收费实重": "",
                    "请选择付款方式": "",
                    "运单收货中，请通知录单员提交后在重新录入！": "",
                    "已审单，不允许补录！": "",
                    "获取文件路径异常": "",
                    "收费重为0，不允许保存": "",
                    "指定路线<": "",
                    ">允许收货件数为<": "",
                    ">，范围外不允许收货": "",
                    ">允许收货实重为<": "",
                    ">允许收货材重为<": "",
                    ">允许收货重量为<": "",
                    "指定路线限制货物类型<": "",
                    ">，不允许收货": "",
                    "请输入到付金额!": "",
                    "请选择到付币别!": "",
                    "请输入付款客户!": "",
                    "请输入申报价值币别!": "",
                    "请选择代收币别!": "",
                    "客户管理客户的付款方式为CA不允许录入PP！": "",
                    "请选择费用!": "",
                    "请输入运费!": "",
                    "请录入运费!": "",
                    "打印完成": "",
                    "修改成功": "",
                    "补录成功": "",
                    "审单成功": "",
                    "新增成功": "",
                    "客户已停用，不能收货!": "",
                    "客户已暂停，不能收货!": "",
                    "付款客户获取失败！": "",
                    "请输入付款客户编码！": "",
                    "当前指定路线的计抛方式发生变化，收费重由<": "",
                    ">变为<": "",
                    "当前指定路线的计抛方式发生变化，请重新保存单件信息": "",
                    "当前指定路线的材积除以数由<": "",
                    ">改为<": "",
                    ">，请重新保存单件信息": "",
                    "请选择需要删除的单件信息!": "",
                    "确认删除当前单件信息？": "",
                    "提示": "",
                    "取消": "",
                    "确定删除当前所有单件信息？": "",
                    "实重材重同时为0，不允许保存和关闭": "",
                    "存在为0数据,不允许保存和关闭": "",
                    "请先保存单件信息！": "",
                    "存在为空数据,不允许保存和关闭": "",
                    "单件信息件数与运单件数不一致，是否继续保存": "",
                    "单件取大不计抛": "",
                    "请选择指定路线!": "",
                    "录入件数为": "",
                    "件，而单件数为": "",
                    "件，是否清除多余的件数": "",
                    "流水号位数不够，请重新设置": "",
                    "子单生成规则未设置，请重新设置": "",
                    "内容有修改,是否确认关闭？": "",
                    "单号输入不规范，请重新输入！": "",
                    "请输入需要导入的信息!": "",
                    "请输入0-9999之间的重量": "",
                    "确定删除此行吗？": "",
                    "请先输入收件电话!": "",
                    "请先输入收件地址!": "",
                    "请先输入收件人!": "",
                    "保存收件人信息成功!": "",
                    "请先选择寄件网点!": "",
                    "请先选择寄件日期!": "",
                    "请先选择客户!": "",
                    "进来了": "",
                    "删除成功!": "",
                    "请先输入寄件人!": "",
                    "请先输入寄件人电话!": "",
                    "保存寄件人信息成功!": "",
                    "文件大小不能大于10MB": "",
                    "不能上传jsp,bat,sh,js,exe文件": "",
                    "选填，200字符以内": "",
                },
                "fdmanifestaudit": {
                    "运单补录": "",
                    "审单": "",
                    "录单日期": "",
                    "录单网点": "",
                    "录单员": "",
                    "客户": "",
                    "审单状态": "",
                    "查询": "",
                    "重置": "",
                    "水单详情": "",
                    "关闭": "",
                    "查看水单": "",
                    "运单号码": "",
                    "参考编号": "",
                    "转单号码": "",
                    "寄件日期": "",
                    "寄件网点": "",
                    "取件员": "",
                    "指定路线": "",
                    "目的地": "",
                    "报关方式": "",
                    "货物类型": "",
                    "包装类型": "",
                    "件数": "",
                    "收费实重": "",
                    "付款方式": "",
                    "税金付款": "",
                    "收件备注": "",
                    "运单图片": "",
                    "补录人": "",
                    "补录时间": "",
                    "审单人": "",
                    "审单时间": "",
                    "数据来源": "",
                    "录单时间": "",
                    "请选择一行要补录的待审核数据！": "",
                    "请选择一行要补录的数据！": "",
                    "审单成功": "",
                    "请至少选择一行数据！": "",
                    "选择的数据非【已收款】状态,不能审核": "",
                    "请选择需要批量审核的客户收款数据": "",
                },
            },
            "manifest": {
                "manifest": {
                    "保存": "",
                    "取件模式": "",
                    "客户": "",
                    "报关方式": "",
                    "取件员": "",
                    "运单号码": "",
                    "重置单号": "",
                    "参考编号": "",
                    "转单号码": "",
                    "指定路线": "",
                    "目的地": "",
                    "货物类型": "",
                    "收件邮编": "",
                    "偏远": "",
                    "收件城市": "",
                    "申报价值": "",
                    "包装类型": "",
                    "件数": "",
                    "称重": "",
                    "收费实重": "",
                    "收费材重": "",
                    "收费重": "",
                    "中文品名": "",
                    "收件备注": "",
                    "预报重量": "",
                    "预报指定路线": "",
                    "其他科目": "",
                    "金额": "",
                    "币别": "",
                    "收件问题": "",
                    "付款方式": "",
                    "到付款": "",
                    "税金付款": "",
                    "代收款": "",
                    "新增": "",
                    "修改": "",
                    "取消": "",
                    "删除": "",
                    "打印条码": "",
                    "收货标签": "",
                    "发票标签": "",
                    "打印清单": "",
                    "单件称重": "",
                    "合并计算": "",
                    "收货提交": "",
                    "设置": "",
                    "全部": "",
                    "单件信息": "",
                    "运单信息": "",
                    "注意": "",
                    "以下录入的都为单件信息": "",
                    "单件进位规则": "",
                    "单票计抛规则": "",
                    "单票进位规则": "",
                    "序号": "",
                    "操作": "",
                    "实重": "",
                    "长": "",
                    "宽": "",
                    "高": "",
                    "除以数": "",
                    "材重": "",
                    "最小重量": "",
                    "生效类型": "",
                    "包装项目": "",
                    "包装费": "",
                    "包装说明": "",
                    "子单号码": "",
                    "同步复制实重": "",
                    "尺寸复制": "",
                    "全部清除": "",
                    "全部删除": "",
                    "导出": "",
                    "关闭": "",
                    "其他收件客户": "",
                    "显示当前网点": "",
                    "当前收货用户的数据": "",
                    "显示当前网点数据": "",
                    "收货用户": "",
                    "客户编码": "",
                    "客户名称": "",
                    "票数": "",
                    "运费": "",
                    "其他费用": "",
                    "查询": "",
                    "单价": "",
                    "最低价格": "",
                    "最高价格": "",
                    "偏远费": "",
                    "含燃油": "",
                    "列表双击可选中邮编": "",
                    "待确认的收货问题": "",
                    "问题编码": "",
                    "问题状态": "",
                    "问题描述": "",
                    "可选问题状态": "",
                    "请输入内容": "",
                    "待确认问题": "",
                    "收货提交后自动生成港前问题件": "",
                    "由客服跟进处理": "",
                    "收件录单设置": "",
                    "扫描规则": "",
                    "强制输入尺寸": "",
                    "邮编或城市必填其一": "",
                    "件数空格时打印收货标签": "",
                    "件数空格时打印发票标签": "",
                    "允许跨网点收货": "",
                    "保存时计算运费": "",
                    "保留上一票信息": "",
                    "运费为": "",
                    "时处理": "",
                    "限制收货": "",
                    "确认提示": "",
                    "不提示不限制": "",
                    "提示不限制": "",
                    "子单生成规则": "",
                    "固定位": "",
                    "流水号位数": "",
                    "最大打印件数": "",
                    "短信发送": "",
                    "预报订单列表": "",
                    "多次扫描记录列表": "",
                    "继续合并": "",
                    "请选择客户": "",
                    "请输入运单号码": "",
                    "请选择报关方式": "",
                    "请选择指定路线": "",
                    "请选择目的地": "",
                    "请选择货物类型": "",
                    "请选择包装类型": "",
                    "请输入件数": "",
                    "请输入收费实重": "",
                    "请选择付款方式": "",
                    "请选择税金付款": "",
                    "请选择取件员": "",
                    "待确认": "",
                    "英文品名": "",
                    "计抛方式": "",
                    "预报重": "",
                    "寄件日期": "",
                    "国家简码": "",
                    "州/省": "",
                    "城市": "",
                    "起始邮编": "",
                    "终止邮编": "",
                    "备注": "",
                    "扫描单号": "",
                    "扫描次数": "",
                    "预报件数": "",
                    "目的地名": "",
                    "合并成功!": "",
                    "合并计算失败!": "",
                    "参考编号<": "",
                    ">已存在，请尽量避免重复数据。是否继续录单？": "",
                    "提示": "",
                    "确定": "",
                    "收件城市或收件邮编不明确，不能直接选择": "",
                    "未查询到偏远信息!": "",
                    "指定路线不能为空": "",
                    "目的地不能为空": "",
                    "无可合并计算数据!": "",
                    "无可合并计算数据 !": "",
                    "{附加项目:": "",
                    "单件取大不计抛": "",
                    ",偏远": "",
                    "订单预报重量为": "",
                    "，与收货重": "",
                    "不符，请检查排货是否准确": "",
                    ",偏远费：": "",
                    "无数据": "",
                    "D类": "",
                    "单独报关": "",
                    ",单独报关,": "",
                    "单独报关,": "",
                    ",单独报关": "",
                    "请先选择客户": "",
                    "客户申请暂扣，限制收货": "",
                    "运单号码<": "",
                    ">的录单网点为<": "",
                    ">,不属于当前网点收货的运单": "",
                    "当前指定路线的计抛方式发生变化，收费重由<": "",
                    ">变为<": "",
                    "当前指定路线的计抛方式发生变化，请重新保存单件信息": "",
                    "当前指定路线的材积除以数由<": "",
                    ">改为<": "",
                    ">，请重新保存单件信息": "",
                    "关税预付": "",
                    "第三方关税": "",
                    ",关税预付,": "",
                    "关税预付,": "",
                    ",关税预付": "",
                    ",第三方关税,": "",
                    "第三方关税,": "",
                    ",第三方关税": "",
                    "偏远邮编": "",
                    "偏远,": "",
                    ",偏远,": "",
                    "收费重为0，不允许保存": "",
                    "请输入转单号码": "",
                    "请输入参考编号": "",
                    "指定路线<": "",
                    ">允许收货件数为<": "",
                    ">，范围外不允许收货": "",
                    ">允许收货实重为<": "",
                    ">允许收货材重为<": "",
                    ">允许收货重量为<": "",
                    "指定路线限制货物类型<": "",
                    ">，不允许收货": "",
                    "件数与单件信息不匹配，请重新输入!": "",
                    "请选择到付币别!": "",
                    "请输入申报价值币别!": "",
                    "请选择代收币别!": "",
                    "请选择科目!": "",
                    "请选择科目币别!": "",
                    "收件邮编和收件城市不能同时为空，请重新输入!": "",
                    "运费为0，不允许保存": "",
                    "运费为0，是否继续保存？": "",
                    "运费为0！": "",
                    "新增成功": "",
                    "修改成功": "",
                    "票": "",
                    "客户无效，请重新选择!": "",
                    "客户已停用，不能收货!": "",
                    "客户已暂停，不能收货!": "",
                    "不能收货": "",
                    "允许收货": "",
                    "指定路线的收费重的材积除以数与单件进位规则发生变化，收费材积和收费重将重新计算": "",
                    "请选择指定路线!": "",
                    "录入件数为": "",
                    "件，而单件数为": "",
                    "件，是否清除多余的件数": "",
                    "实重材重同时为0，不允许保存和关闭": "",
                    "存在为0数据,不允许保存和关闭": "",
                    "存在为空数据,不允许保存和关闭": "",
                    "存在不收件，请重新填写标红件！": "",
                    "单件信息件数与运单件数不一致，是否继续保存": "",
                    "请选择需要删除的单件信息!": "",
                    "确认删除当前单件信息？": "",
                    "确定删除当前所有单件信息？": "",
                    "合计": "",
                    "客户数：": "",
                    "内容有修改,是否取消编辑？": "",
                    "请选择运单": "",
                    "此操作将删除该运单, 是否继续?": "",
                    "删除成功": "",
                    "请在右表选择客户后再提交": "",
                    "没有待提交运单，请保存运单后再提交": "",
                    "没有可以提交的运单，请检查！": "",
                    "提交成功！": "",
                    "实重材重取大": "",
                    "内容有修改,是否确认关闭？": "",
                    "没有待提交运单，请保存运单后再打印": "",
                    "打印完成": "",
                    "请在右表选择客户后再打印": "",
                    "流水号位数不够，请重新设置": "",
                    "子单生成规则未设置，请重新设置": "",
                    "问题描述不能为空": "",
                    "保存成功": "",
                    "根据指定路线<": "",
                    ">设置的邮编目的地规则，收件邮编<": "",
                    ">分拣的目的地为<": "",
                },
                "importmodify": {
                    "导入模版": "",
                    "模版下载": "",
                    "新增模板": "",
                    "寄件网点": "",
                    "导入": "",
                    "导入文件格式支持": "",
                    "文件大小不超过": "",
                    "导入时": "",
                    "请确认导入模板中表头的完整性": "",
                    "导入重量小于收费重时": "",
                    "不修改": "",
                    "适用于提前导入代理重量": "",
                    "批次号": "",
                    "导入文件": "",
                    "导入时间": "",
                    "状态": "",
                    "总行数": "",
                    "错误行数": "",
                    "文件下载": "",
                    "历史日志": "",
                    "导入历史日志": "",
                    "请输入": "",
                    "行号": "",
                    "运单号码": "",
                    "错误说明": "",
                    "请选择模版！": "",
                    "运单修改标准模版": "",
                    "请选择导入模版！": "",
                    "请选择寄件网点！": "",
                    "导入文件不能超过10MB": "",
                    "解析中": "",
                    "失败": "",
                    "导入中": "",
                    "上传中": "",
                    "上传失败": "",
                    "解析失败": "",
                    "验证中": "",
                    "验证失败": "",
                    "成功": "",
                    "运单修改成功": "",
                },
                "manifestSpecialLine": {
                    "保存": "",
                    "问题件": "",
                    "面单打印": "",
                    "设置面单默认格式": "",
                    "设置": "",
                    "基本信息": "",
                    "收件人": "",
                    "客户": "",
                    "寄件网点": "",
                    "指定路线": "",
                    "目的地": "",
                    "寄件日期": "",
                    "运单号码": "",
                    "参考编号": "",
                    "走货路线": "",
                    "收件税号": "",
                    "选择收件人": "",
                    "收件公司": "",
                    "收件电话": "",
                    "收件地址": "",
                    "收件城市": "",
                    "收件邮编": "",
                    "单件信息": "",
                    "序号": "",
                    "操作": "",
                    "删除": "",
                    "中文品名": "",
                    "英文品名": "",
                    "件数": "",
                    "实重": "",
                    "长": "",
                    "宽": "",
                    "高": "",
                    "体积": "",
                    "数量": "",
                    "单价": "",
                    "总价": "",
                    "海关编码": "",
                    "包装类型": "",
                    "货物类型": "",
                    "报关方式": "",
                    "付款方式": "",
                    "总件数": "",
                    "收费重": "",
                    "应收运费": "",
                    "到付款": "",
                    "代收款": "",
                    "收货备注": "",
                    "出货备注": "",
                    "收件人信息": "",
                    "选取": "",
                    "双击可直接选择收件人": "",
                    "扫描规则": "",
                    "保存时自动打印面单": "",
                    "自动保存收件人信息": "",
                    "运费为": "",
                    "时处理": "",
                    "限制收货": "",
                    "确认提示": "",
                    "不提示不限制": "",
                    "提示不限制": "",
                    "关闭": "",
                    "问题件登记": "",
                    "录单设置": "",
                    "请选择客户": "",
                    "请选择指定路线": "",
                    "请选择目的地": "",
                    "请输入运单号码": "",
                    "请选择包装类型": "",
                    "请选择货物类型": "",
                    "请选择报关方式": "",
                    "请输入件数": "",
                    "请选择付款方式": "",
                    "获取运单号失败!": "",
                    "请先选择客户": "",
                    "当前客户未设置收件人!": "",
                    "中文品名不能为空": "",
                    "件数不能为空": "",
                    "件数必须大于等于1": "",
                    "实重不能为空": "",
                    "实重必须大于0": "",
                    "长不能为空": "",
                    "长必须大于0": "",
                    "宽不能为空": "",
                    "宽必须大于0": "",
                    "高不能为空": "",
                    "高必须大于0": "",
                    "确定删除此行吗？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "进入批价": "",
                    "开始批价": "",
                    "运单号为空,可能未设置单号规则": "",
                    "运费为0，不允许保存": "",
                    "运费为0，是否继续保存？": "",
                    "运费为0！": "",
                    "保存成功": "",
                    "运单号码<": "",
                    ">收货中，限制修改!": "",
                    "请先选择指定路线": "",
                    "指定路线[": "",
                    "]成功绑定面单[": "",
                    "9610面单": "",
                    "打印完成": "",
                    "该指定路线未设置默认面单格式": "",
                    "内容有修改,是否确认关闭？": "",
                    "根据指定路线<": "",
                    ">设置的邮编目的地规则，收件邮编<": "",
                    ">分拣的目的地为<": "",
                    "流水号位数不够，请重新设置": "",
                    "子单生成规则未设置，请重新设置": "",
                },
            },
            "receivefast": {
                "receivefast": {
                    "客户": "",
                    "指定路线": "",
                    "收货包号": "",
                    "收费实重": "",
                    "自动": "",
                    "收费尺寸": "",
                    "自动保留": "",
                    "扫描单号": "",
                    "收货设置": "",
                    "未收货订单": "",
                    "待提交运单": "",
                    "正常票数": "",
                    "票": "",
                    "异常票数": "",
                    "快速收货设置": "",
                    "扫描单号类型": "",
                    "运单号码": "",
                    "参考编号": "",
                    "转单号码": "",
                    "扫描规则": "",
                    "保存后自动打印": "",
                    "保存后自动提交": "",
                    "偏远计算": "",
                    "允许跨网点收货": "",
                    "报音": "",
                    "分拣码报音": "",
                    "限制收货报音": "",
                    "目的地报音": "",
                    "异常": "",
                    "少重": "",
                    "收费重": "",
                    "客户重": "",
                    "超重": "",
                    "客户异常": "",
                    "预报客户与选择客户不符": "",
                    "路线异常": "",
                    "预报指定路线与选择指定路线不符": "",
                    "限制收货": "",
                    "保存": "",
                    "关闭": "",
                    "称重设备": "",
                    "设备名称": "",
                    "设备类型": "",
                    "端口": "",
                    "波特率": "",
                    "开始采集": "",
                    "重量采集设置": "",
                    "异常类型": "",
                    "件数": "",
                    "收费材重": "",
                    "尺寸": "",
                    "目的地": "",
                    "货物类型": "",
                    "分拣码": "",
                    "收费尺寸长宽高不能为0": "",
                    "请输入扫描单号": "",
                    "请选择客户": "",
                    "请选择指定路线": "",
                    "请输入收货包号": "",
                    "请输入收费实重": "",
                    "流水号位数不够，请重新设置": "",
                    "子单生成规则未设置，请重新设置": "",
                    "内容有修改,是否确认关闭？": "",
                    "请选择设备": "",
                    "请填写端口": "",
                    "请填写1-20的端口号": "",
                    "采集失败！": "",
                    "电子秤": "",
                },
                "openorder": {
                    "选择收货": "",
                    "全部收货": "",
                    "选择取消": "",
                    "订单日期": "",
                    "客户": "",
                    "指定路线": "",
                    "订单状态": "",
                    "查询": "",
                    "重置": "",
                    "取消原因": "",
                    "注意": "",
                    "最多不能超过": "",
                    "个字符": "",
                    "您选取": "",
                    "待收货": "",
                    "的订单共": "",
                    "笔": "",
                    "是否取消订单": "",
                    "保存": "",
                    "关闭": "",
                    "取消订单": "",
                    "运单号码": "",
                    "参考编号": "",
                    "转单号码": "",
                    "订单编号": "",
                    "订单包号": "",
                    "寄件网点": "",
                    "货物类型": "",
                    "目的地": "",
                    "件数": "",
                    "客户重": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请选择创建日期": "",
                    "请选择至少一行数据": "",
                    "请选择至少一行待收货数据": "",
                    "收货异常": "",
                    "收货成功": "",
                    "笔，已收货": "",
                    "笔，无预报": "",
                    "收货成功！": "",
                    "已提交收货请求！": "",
                    "请选择一个客户后再进行全部收货": "",
                    "未获取到对应数据": "",
                    "全部收货完成！": "",
                    "取消异常": "",
                    "取消成功": "",
                    "笔，取消失败": "",
                    "取消成功！": "",
                    "内容有修改,是否确认关闭？": "",
                },
                "waitwaybillsubmit": {
                    "收货提交": "",
                    "删除": "",
                    "寄件日期": "",
                    "客户": "",
                    "指定路线": "",
                    "查询": "",
                    "重置": "",
                    "运单号码": "",
                    "参考编号": "",
                    "转单号码": "",
                    "寄件网点": "",
                    "目的地": "",
                    "包装类型": "",
                    "货物类型": "",
                    "报关方式": "",
                    "件数": "",
                    "收费重": "",
                    "请选择寄件日期": "",
                    "请选择至少一行数据": "",
                    "提交异常": "",
                    "提交成功": "",
                    "笔，提交失败": "",
                    "提交成功！": "",
                    "此操作将删除运单, 是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "请选择至少一个运单": "",
                    "删除异常": "",
                    "删除成功": "",
                    "笔，删除失败": "",
                    "删除成功！": "",
                }
            },
            "bagreceive": {
                "bagreceive": {
                    "客户": "",
                    "指定路线": "",
                    "货物类型": "",
                    "收费实重": "",
                    "自动": "",
                    "收费尺寸": "",
                    "自动保留": "",
                    "收货包号": "",
                    "未收货包": "",
                    "收货包管理": "",
                    "称重设备": "",
                    "设备名称": "",
                    "设备类型": "",
                    "端口": "",
                    "波特率": "",
                    "开始采集": "",
                    "关闭": "",
                    "客户名称": "",
                    "总票数": "",
                    "预报实重": "",
                    "收费重": "",
                    "请输入": "",
                    "重量采集设置": "",
                    "扫描装包失败！": "",
                    "请选择设备": "",
                    "请填写端口": "",
                    "请填写1-20的端口号": "",
                    "采集失败！": "",
                    "电子秤": "",
                    "内容有修改,是否确认关闭？": "",
                    "客户不能为空": "",
                    "指定路线不能为空": "",
                    "货物类型不能为空": "",
                    "收费实重不能为空": "",
                    "收费尺寸长宽高不能为0": "",
                    "收货包号不能为空": "",
                    "你确定删除该预报包吗？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "预报包删除成功！": "",
                    "预报包删除失败！": "",
                    "请选择一行数据": "",
                },
                "notreceivebag": {
                    "收货": "",
                    "取消": "",
                    "导出": "",
                    "预报日期": "",
                    "客户": "",
                    "指定路线": "",
                    "包状态": "",
                    "查询": "",
                    "重置": "",
                    "取消原因": "",
                    "确认": "",
                    "关闭": "",
                    "取消确认": "",
                    "预报包号": "",
                    "客户编码": "",
                    "客户名称": "",
                    "货物类型": "",
                    "总包数": "",
                    "总票数": "",
                    "运单重": "",
                    "预报实重": "",
                    "预报材重": "",
                    "预报重": "",
                    "预报体积": "",
                    "预报长宽高": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "预报日期不能为空": "",
                    "取消异常": "",
                    "取消成功！": "",
                    "请选择至少一行数据": "",
                    "请选择至少一行待收货数据": "",
                    "收货异常": "",
                    "收货成功！": "",
                    "未收货查询": "",
                    "内容有修改,是否确认关闭？": "",
                    "提示": "",
                    "确定": "",
                },
                "receivebagmanagement": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "收货提交": "",
                    "撤销提交": "",
                    "导出": "",
                    "收货日期": "",
                    "收货网点": "",
                    "客户": "",
                    "包状态": "",
                    "数据来源": "",
                    "查询": "",
                    "重置": "",
                    "收货包号信息": "",
                    "收货包号": "",
                    "指定路线": "",
                    "货物类型": "",
                    "总包数": "",
                    "总票数": "",
                    "预报重": "",
                    "收货重": "",
                    "取件员": "",
                    "备注": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "客户编码": "",
                    "客户名称": "",
                    "运单重": "",
                    "预报实重": "",
                    "预报材重": "",
                    "预报尺寸": "",
                    "预报体积": "",
                    "收货实重": "",
                    "收货材重": "",
                    "收货尺寸": "",
                    "收货体积": "",
                    "预报日期": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请输入": "",
                    "收货日期不能为空": "",
                    "确定要删除吗？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "请选择一行数据": "",
                    "删除收货包异常": "",
                    "删除成功！": "",
                    "收货异常": "",
                    "收货成功！": "",
                    "确定要撤销吗？": "",
                    "撤销提交异常": "",
                    "撤销成功！": "",
                    "新增收货包": "",
                    "添加异常": "",
                    "添加成功！": "",
                    "修改异常": "",
                    "修改成功！": "",
                    "收货包管理": "",
                    "修改收货包": "",
                    "内容有修改,是否确认关闭？": "",
                },
            },
            "manifestquery": {
                "manifestQuery": {
                    "修改": "",
                    "删除": "",
                    "明细": "",
                    "专线预报导出": "",
                    "快速退返": "",
                    "打印": "",
                    "嘉里": "",
                    "标准面单": "",
                    "越南面单": "",
                    "香港面单": "",
                    "收件清单打印": "",
                    "导出": "",
                    "单号导出": "",
                    "运单号导出": "",
                    "转单号导出": "",
                    "导出单件信息": "",
                    "单件信息": "",
                    "更多条件": "",
                    "提取寄件人": "",
                    "标签打印": "",
                    "发票打印": "",
                    "寄件日期": "",
                    "出货日期": "",
                    "寄件网点": "",
                    "查录单": "",
                    "客户类型": "",
                    "客户": "",
                    "含子客户": "",
                    "查询": "",
                    "重置": "",
                    "业务类型": "",
                    "指定路线分类": "",
                    "指定路线": "",
                    "包装类型": "",
                    "付款方式": "",
                    "货物类型": "",
                    "税金付款": "",
                    "销售员": "",
                    "跟单员": "",
                    "有货款": "",
                    "代理退件": "",
                    "目的地": "",
                    "件数": "",
                    "走货路线分类": "",
                    "走货路线": "",
                    "派件网点": "",
                    "录单员": "",
                    "运单状态": "",
                    "报关方式": "",
                    "运单": "",
                    "参考": "",
                    "转单": "",
                    "模糊": "",
                    "运单信息": "",
                    "启用": "",
                    "保存": "",
                    "关闭": "",
                    "代理报价信息": "",
                    "操作": "",
                    "报价名称": "",
                    "代理": "",
                    "渠道": "",
                    "币别": "",
                    "备注": "",
                    "唯一走货路线": "",
                    "有效运单": "",
                    "根据指定路线或目的地": "",
                    "只有唯一的一条走货路线": "",
                    "价格最优路线": "",
                    "在第": "",
                    "点的基础上": "",
                    "如有多条走货路线时": "",
                    "价格最优的走货路线为价格最优路线": "",
                    "如价格计算为": "",
                    "除外": "",
                    "重量优先路线": "",
                    "当包装类型为": "",
                    "并且在收货时有录入单件信息时": "",
                    "如果走货路线的材积除以数": "",
                    "与指定路线的材积除以数不相同时": "",
                    "将重新计算出货重": "",
                    "如果此走货路线为价格最优的路线": "",
                    "为重": "",
                    "量最优路线": "",
                    "无有效价格": "",
                    "无效运单": "",
                    "如多条走货路线计算价格都为": "",
                    "为无有效价格": "",
                    "无走货路线": "",
                    "没有对应的走货路线": "",
                    "为无走货路线": "",
                    "是": "",
                    "否": "",
                    "按单号导出": "",
                    "取消": "",
                    "退返方式": "",
                    "退返单号": "",
                    "退返备注": "",
                    "您选取了": "",
                    "笔记录数据": "",
                    "其中可退返": "",
                    "笔": "",
                    "确定": "",
                    "新增运单": "",
                    "请输入": "",
                    "请选择": "",
                    "运单号(不能重复)*": "",
                    "国内仓库": "",
                    "转单号": "",
                    "分货标签": "",
                    "收件日期*": "",
                    "客户(全称或者代号)*": "",
                    "客户(客户全称或者代号)*": "",
                    "走货渠道": "",
                    "价格渠道": "",
                    "货物性质(带磁/带电/纺织品等)*": "",
                    "清关方式": "",
                    "地址类型/亚马逊/商业地址*": "",
                    "卡车预约号/ReferenceID": "",
                    "收货人邮编*": "",
                    "收件人国家代码(二字代码)*": "",
                    "收货人公司名": "",
                    "收货人姓名": "",
                    "省份/州": "",
                    "收货城市": "",
                    "收货地址1": "",
                    "收货地址2": "",
                    "收货人电话": "",
                    "收货人邮箱": "",
                    "其他地址/门牌": "",
                    "起运地": "",
                    "预付/到付": "",
                    "代收币种": "",
                    "代收金额": "",
                    "外部备注": "",
                    "VAT号": "",
                    "EORI号": "",
                    "VAT公司名": "",
                    "VAT地址": "",
                    "是否购买保险": "",
                    "总件数*": "",
                    "分件数*": "",
                    "行号*": "",
                    "单件实重": "",
                    "长": "",
                    "宽": "",
                    "高": "",
                    "FBA子单号/箱唛号*": "",
                    "中文品名*": "",
                    "英文品名*": "",
                    "产品品牌": "",
                    "产品海关编码*": "",
                    "单件产品申报数量*": "",
                    "单个产品申报单价*": "",
                    "单个产品净重*": "",
                    "采购单价(RMB)": "",
                    "Sku码": "",
                    "型号": "",
                    "材质": "",
                    "用途": "",
                    "包装": "",
                    "产品下载/产品库链接": "",
                    "产品销售链接": "",
                    "错误": "",
                    "导入出错提示": "",
                    "系统单号": "",
                    "国外海关编码": "",
                    "请选择要打印订单的数据": "",
                    "异常": "",
                    "请选择运单": "",
                    "请选择至少一行数据": "",
                    "提取成功": "",
                    "运单号码": "",
                    "参考编号": "",
                    "转单号码": "",
                    "实重": "",
                    "除以数": "",
                    "材重": "",
                    "收费重量": "",
                    "体积": "",
                    "包装项目": "",
                    "包装费": "",
                    "包装说明": "",
                    "包号/板号": "",
                    "录单网点": "",
                    "客户编码": "",
                    "客户名称": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "寄件邮箱": "",
                    "收件人": "",
                    "收件电话": "",
                    "收件邮编": "",
                    "收件城市": "",
                    "收件地址": "",
                    "目的地编码": "",
                    "中文品名": "",
                    "英文品名": "",
                    "代收款": "",
                    "代收币别": "",
                    "预报重": "",
                    "收费实重": "",
                    "收费材重": "",
                    "收费体积": "",
                    "收费重": "",
                    "申报价值": "",
                    "申报价值币别": "",
                    "问题件": "",
                    "问题最新描述": "",
                    "退返客户": "",
                    "出货重": "",
                    "上板": "",
                    "机场代码": "",
                    "走货路线名": "",
                    "寄件账号": "",
                    "总运单号": "",
                    "交接单号": "",
                    "收件备注": "",
                    "出货备注": "",
                    "最新轨迹状态": "",
                    "最新轨迹网点": "",
                    "是否偏远": "",
                    "数据来源": "",
                    "港前客服": "",
                    "港后客服": "",
                    "应收运费": "",
                    "请输入单号！": "",
                    "请选择运单！": "",
                    "退返客户失败！": "",
                    "退返客户成功！": "",
                    "寄件日期不能为空": "",
                    "已出货，不允许删除！": "",
                    "确定要删除<": "",
                    ">吗？": "",
                    "提示": "",
                    "请选择一行数据": "",
                    "退返方式等于{第三方快递}时，退返单号必填": "",
                    "操作成功": "",
                    "删除运单异常": "",
                    "删除成功！": "",
                    "自动运单异常": "",
                    "自动运单成功！": "",
                    "修改异常": "",
                    "修改成功！": "",
                    "添加异常": "",
                    "添加成功！": "",
                    "运单查询": "",
                    "运单导出": "",
                    "创建导出任务，请稍后在导出列表中下载！": "",
                    "每行高亮": "",
                    "背景色设置": "",
                    "展开开关": "",
                    "请选择需要打印的数据": "",
                    "9610面单": "",
                    "打印完成": "",
                    "勾选的多条运单的客户必须是同一个才可打印！": "",
                    "流水号位数不够，请重新设置": "",
                    "子单生成规则未设置，请重新设置": "",
                },
                "manifestmodify": {
                    "运单": "",
                    "运单号码": "",
                    "转单号码": "",
                    "参考编号": "",
                    "客户": "",
                    "指定路线": "",
                    "货物信息": "",
                    "报关方式": "",
                    "包装类型": "",
                    "货物类型": "",
                    "件数": "",
                    "收费实重": "",
                    "收费材重": "",
                    "收费重": "",
                    "出货实重": "",
                    "出货材重": "",
                    "出货重": "",
                    "申报价值": "",
                    "中文品名": "",
                    "英文品名": "",
                    "数量": "",
                    "收货备注": "",
                    "出货备注": "",
                    "寄件人": "",
                    "寄件公司": "",
                    "寄件电话": "",
                    "寄件地址": "",
                    "寄件国家": "",
                    "寄件州": "",
                    "省": "",
                    "寄件城市": "",
                    "寄件邮编": "",
                    "寄件网点": "",
                    "寄件日期": "",
                    "取件员": "",
                    "目的地": "",
                    "走货路线": "",
                    "派件网点": "",
                    "费用结算": "",
                    "付款方式": "",
                    "到付款": "",
                    "税金付款": "",
                    "代收款": "",
                    "其他科目": "",
                    "金额": "",
                    "币别": "",
                    "结算备注": "",
                    "收件人": "",
                    "收件公司": "",
                    "收件电话": "",
                    "收件地址": "",
                    "收件税号": "",
                    "收件国家": "",
                    "收件州": "",
                    "收件城市": "",
                    "收件邮编": "",
                    "信息": "",
                    "显示": "",
                    "序号": "",
                    "操作": "",
                    "删除": "",
                    "单价": "",
                    "总价": "",
                    "海关编码": "",
                    "净重": "",
                    "毛重": "",
                    "原产地": "",
                    "备注": "",
                    "单件信息": "",
                    "运单信息": "",
                    "注意": "",
                    "以下录入的都为单件信息": "",
                    "单件进位规则": "",
                    "单票计抛规则": "",
                    "修改": "",
                    "单票进位规则": "",
                    "新增": "",
                    "实重": "",
                    "长": "",
                    "宽": "",
                    "高": "",
                    "除以数": "",
                    "材重": "",
                    "最小重量": "",
                    "生效类型": "",
                    "包装项目": "",
                    "包装费": "",
                    "包装说明": "",
                    "保存": "",
                    "同步复制实重": "",
                    "尺寸复制": "",
                    "全部清除": "",
                    "全部删除": "",
                    "导出": "",
                    "请输入运单号码": "",
                    "请选择寄件网点": "",
                    "请选择寄件日期": "",
                    "请选择客户": "",
                    "请选择指定路线": "",
                    "请选择目的地": "",
                    "请选择报关方式": "",
                    "请选择货物类型": "",
                    "请选择包装类型": "",
                    "请输入件数": "",
                    "请输入收费实重": "",
                    "请输入出货实重": "",
                    "请选择付款方式": "",
                    "保存&S": "",
                    "根据指定路线<": "",
                    ">设置的邮编目的地规则，收件邮编<": "",
                    ">分拣的目的地为<": "",
                    "提示": "",
                    "偏远": "",
                    ",偏远,": "",
                    "偏远,": "",
                    ",偏远": "",
                    "运单号码<": "",
                    ">收货中，限制修改!": "",
                    "未找到对应运单，请重新填写": "",
                    "修改成功，运单<": "",
                    ">已出货，指定路线、目的地、件数、包装类型、收费重修改后可能影响到港后，请通知港后客服！": "",
                    "收费重为0，不允许保存": "",
                    "请选择到付币别!": "",
                    "请选择代收币别!": "",
                    "修改成功！": "",
                    "追踪进行中，请稍候查询": "",
                    "物流助手初始化失败,请稍后重试": "",
                    "助手返回任务id失败": "",
                    "追踪结束": "",
                    "已加入自动追踪任务": "",
                    "--请求轨迹原数据失败--": "",
                    "当前指定路线的计抛方式发生变化，收费重由<": "",
                    ">变为<": "",
                    "当前指定路线的计抛方式发生变化，请重新保存单件信息": "",
                    "当前指定路线的材积除以数由<": "",
                    ">改为<": "",
                    ">，请重新保存单件信息": "",
                    "当前指定路线为空改为<": "",
                    "单件取大不计抛": "",
                    "请选择指定路线!": "",
                    "录入件数为": "",
                    "件，而单件数为": "",
                    "件，是否清除多余的件数": "",
                    "确定": "",
                    "取消": "",
                    "实重材重同时为0，不允许保存和关闭": "",
                    "存在为0数据,不允许保存和关闭": "",
                    "存在为空数据,不允许保存和关闭": "",
                    "{附加项目:": "",
                    "存在不收件，请重新填写标红件！": "",
                    "单件信息件数与运单件数不一致，是否继续保存": "",
                    "请选择需要删除的单件信息!": "",
                    "确认删除当前单件信息？": "",
                    "确定删除当前所有单件信息？": "",
                    "确定删除此行吗？": "",
                    "英文品名不能为空": "",
                    "净重必须大于等于0": "",
                    "毛重必须大于等于0": "",
                },
                "manifestQuery2": {
                    "导出": "",
                    "更多条件": "",
                    "寄件日期": "",
                    "寄件网点": "",
                    "录单网点": "",
                    "库存网点": "",
                    "客户": "",
                    "指定路线": "",
                    "可多选": "",
                    "走货路线": "",
                    "目的地": "",
                    "最新轨迹网点": "",
                    "查询": "",
                    "重置": "",
                    "指定路线分类": "",
                    "走货路线分类": "",
                    "排仓分区": "",
                    "货物类型": "",
                    "报关方式": "",
                    "销售员": "",
                    "跟单员": "",
                    "收费重": "",
                    "全部": "",
                    "未出货": "",
                    "待转单": "",
                    "待交接": "",
                    "待上板": "",
                    "已上板": "",
                    "问题件": "",
                    "已退返": "",
                    "漏出货": "",
                    "欠费锁机": "",
                    "已出货": "",
                    "未提取": "",
                    "已提取": "",
                    "运输中": "",
                    "已签收": "",
                    "代理退件": "",
                    "清关延误": "",
                    "派送异常": "",
                    "国外退件": "",
                    "状态": "",
                    "客户编码": "",
                    "客户名称": "",
                    "运单号码": "",
                    "转单号码": "",
                    "参考编号": "",
                    "总运单号": "",
                    "交接单号": "",
                    "板号": "",
                    "目的地编码": "",
                    "排仓分区名称": "",
                    "收件邮编": "",
                    "收件城市": "",
                    "机场代码": "",
                    "中文品名": "",
                    "英文品名": "",
                    "申报价值": "",
                    "申报价值币别": "",
                    "件数": "",
                    "收费实重": "",
                    "收费材重": "",
                    "收费体积": "",
                    "出货重": "",
                    "预报重": "",
                    "包装类型": "",
                    "付款方式": "",
                    "税金付款": "",
                    "收件备注": "",
                    "港前问题件": "",
                    "问题描述": "",
                    "代理取件时间": "",
                    "最新轨迹状态": "",
                    "最新轨迹时间": "",
                    "寄件人公司": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "寄件邮箱": "",
                    "收件公司": "",
                    "收件人": "",
                    "收件地址": "",
                    "港前客服": "",
                    "港后客服": "",
                    "应收运费": "",
                    "派件网点": "",
                    "寄件日期不能为空": "",
                    "&nbsp;&nbsp;票数:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;件数:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;收费实重:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;收费材重:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;收费重:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;出货重:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;预报重:&nbsp;&nbsp;<span style=color: red>": "",
                    "每行高亮": "",
                    "背景色设置": "",
                },
                "stockinprequery": {
                    "导出": "",
                    "入库预查": "",
                    "更多条件": "",
                    "入库时间": "",
                    "库存网点": "",
                    "客户": "",
                    "排仓分区": "",
                    "指定路线分类": "",
                    "可多选": "",
                    "走货路线": "",
                    "目的地": "",
                    "最新状态网点": "",
                    "销售员": "",
                    "跟单员": "",
                    "查询": "",
                    "重置": "",
                    "走货路线分类": "",
                    "录单网点": "",
                    "货物类型": "",
                    "报关方式": "",
                    "收费重": "",
                    "全部": "",
                    "未出货": "",
                    "待转单": "",
                    "待交接": "",
                    "待上板": "",
                    "已上板": "",
                    "预报": "",
                    "问题件": "",
                    "已退返": "",
                    "漏出货": "",
                    "欠费锁机": "",
                    "有库存": "",
                    "状态": "",
                    "客户编码": "",
                    "客户名称": "",
                    "运单号码": "",
                    "转单号码": "",
                    "参考编号": "",
                    "总运单号": "",
                    "交接单号": "",
                    "板号": "",
                    "指定路线": "",
                    "目的地编码": "",
                    "排仓分区名称": "",
                    "收件邮编": "",
                    "收件城市": "",
                    "机场代码": "",
                    "中文品名": "",
                    "英文品名": "",
                    "申报价值": "",
                    "申报价值币别": "",
                    "运单件数": "",
                    "库存件数": "",
                    "收费实重": "",
                    "收费材重": "",
                    "出货重": "",
                    "预报重": "",
                    "包装类型": "",
                    "付款方式": "",
                    "税金付款": "",
                    "收件备注": "",
                    "港前问题件": "",
                    "问题描述": "",
                    "最新轨迹状态": "",
                    "最新轨迹网点": "",
                    "最新轨迹时间": "",
                    "寄件人公司": "",
                    "寄件人": "",
                    "寄件电话": "",
                    "寄件邮箱": "",
                    "收件公司": "",
                    "收件人": "",
                    "收件地址": "",
                    "入库时间不能为空": "",
                    "库存网点不能为空": "",
                    "&nbsp;&nbsp;票数:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;运单件数:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;库存件数:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;收费实重:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;收费材重:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;收费重:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;出货重:&nbsp;&nbsp;<span style=color: red>": "",
                    "&nbsp;&nbsp;预报重:&nbsp;&nbsp;<span style=color: red>": "",
                },
                "invoiceQuery": {
                    "导入修改": "导入修改",
                    "导出": "导出",
                    "查询": "查询",
                    "寄件日期": "寄件日期",
                    "寄件网点": "寄件网点",
                    "指定路线分类": "指定路线分类",
                    "可多选": "可多选",
                    "指定路线": "指定路线",
                    "重置": "重置",
                    "走货路线分类": "走货路线分类",
                    "走货路线": "走货路线",
                    "目的地": "目的地",
                    "货物类型": "货物类型",
                    "报关方式": "报关方式",
                    "运单状态": "运单状态",
                    "单号": "单号",
                    "清关包号": "清关包号",
                    "运单号码": "运单号码",
                    "参考编号": "参考编号",
                    "转单号码": "转单号码",
                    "Invoice信息": "Invoice信息",
                    "中文品名": "中文品名",
                    "英文品名": "英文品名",
                    "数量": "数量",
                    "单价": "单价",
                    "总价": "总价",
                    "海关编码": "海关编码",
                    "材质": "材质",
                    "用途": "用途",
                    "收件信息": "收件信息",
                    "收件税号": "收件税号",
                    "收件人": "收件人",
                    "收件公司": "收件公司",
                    "收件电话": "收件电话",
                    "收件地址": "收件地址",
                    "收件地址2": "收件地址2",
                    "收件地址3": "收件地址3",
                    "收件国家": "收件国家",
                    "收件州/省": "收件州/省",
                    "收件城市": "收件城市",
                    "收件邮编": "收件邮编",
                    "运单信息": "运单信息",
                    "目的地编码": "目的地编码",
                    "包装类型": "包装类型",
                    "件数": "件数",
                    "收费实重": "收费实重",
                    "收费材重": "收费材重",
                    "收费重": "收费重",
                    "派件网点": "派件网点",
                    "客户编码": "客户编码",
                    "客户名称": "客户名称",
                    "寄件日期不能为空": "寄件日期不能为空",
                    "Invoice查询": "Invoice查询",
                    "每行高亮": "每行高亮",
                    "背景色设置": "背景色设置",
                },

            },
            "manifestchangeaudit": {
                "manifestchangeaudit": {
                    "批量审核": "",
                    "全部审核": "",
                    "取消变更": "",
                    "导出": "",
                    "申请变更时间": "",
                    "寄件网点": "",
                    "查录单": "",
                    "变更来源": "",
                    "客户": "",
                    "对账员": "",
                    "变更状态": "",
                    "查询": "",
                    "重置": "",
                    "自动审核": "",
                    "运单号码": "",
                    "转单号码": "",
                    "参考编号": "",
                    "寄件日期": "",
                    "&寄件日期": "",
                    "&寄件网点": "",
                    "&客户编码": "",
                    "&指定路线": "",
                    "&目的地": "",
                    "&包装类型": "",
                    "&收费实重": "",
                    "&收费材重": "",
                    "&计抛规则": "",
                    "&收费重": "",
                    "其他费用": "",
                    "&出货重": "",
                    "&走货路线": "",
                    "&派件网点": "",
                    "&付款方式": "",
                    "&费用合计": "",
                    "&合计币别": "",
                    "&到付款": "",
                    "&到付币别": "",
                    "&报关方式": "",
                    "&货物类型": "",
                    "申请人": "",
                    "审核人": "",
                    "审核时间": "",
                    "请选择申请变更时间": "",
                    "全部审核成功！": "",
                    "请选择至少一行数据": "",
                    "请选择至少一行待审核数据": "",
                    "审核失败！": "",
                    "审核成功！": "",
                    "状态不为待审核，无法取消！": "",
                    "确定取消运单<": "",
                    ">的变更申请？": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "请选择变更记录": "",
                    "取消审核失败！": "",
                    "取消审核成功！": "",
                }
            },
            "barcodeprinting": {
                "barcodeprinting": {
                    "打印": "",
                    "打印设置": "",
                    "扫描单号": "",
                    "件数": "",
                    "份数": "",
                    "起始件数": "",
                    "终止件数": "",
                    "打印选项": "",
                    "收货标签": "",
                    "发票标签": "",
                    "运单标签": "",
                    "设置": "",
                    "验证录单": "",
                    "验证预报": "",
                    "单票打印": "",
                    "打印全部件数": "",
                    "请输入件数": "",
                    "请输入份数": "",
                    "请输入单号": "",
                    "请输入运单号码": "",
                    "起始件数不能小于终止件数": "",
                    "子单号码固定位": "",
                    "子单号码流水号位数": "",
                    "流水号位数不够，请重新设置": "",
                    "子单生成规则未设置，请重新设置": "",
                    "运单已经被使用，请检查": "",
                    "件数不能超过可打印件数": "",
                    "错误打印:": "",
                    "超出最大打印件数,需由运单标签打印:": "",
                    "打印完成": "",
                }
            },
            "checkgoods": {
                "checkgoods": {
                    "扫描单号": "",
                    "运单信息": "",
                    "运单号码": "",
                    "参考编号": "",
                    "指定路线": "",
                    "目的地信息": "",
                    "货物类型": "",
                    "报关方式": "",
                    "包装类型": "",
                    "客户": "",
                    "中文品名": "",
                    "英文品名": "",
                    "件数": "",
                    "数量": "",
                    "收费实重": "",
                    "收费材重": "",
                    "收费重": "",
                    "收件备注": "",
                    "查货状态": "",
                    "正常件": "",
                    "提交": "",
                    "序号": "",
                    "操作": "",
                    "删除": "",
                    "问题状态": "",
                    "问题描述": "",
                    "选择查货问题状态": "",
                    "输入编码或名称后立即查询": "",
                    "问题编码": "",
                    "问题名称": "",
                    "选取": "",
                    "关闭": "",
                    "其它问题": "",
                    "请输入": "",
                    "删除成功！": "",
                    "删除失败！": "",
                    "提交成功！": "",
                    "提交失败1！": "",
                    "无运单数据，请确认后再提交！": "",
                    "扫描单号不能为空！": "",
                    "无运单信息，无法打开其他问题！": "",
                    "请先选择一个问题状态": "",
                    "可在此输入问题描述。扫描下一笔运单,自动保存上-笔运单的查货信息。CTRL+S可以直接保存当前查货记录": "",
                }
            },
            "goodsallocpod": {
                "goodsallocpod": {
                    "货位编码": "",
                    "扫描单号": "",
                    "选取运单": "",
                    "扫描票数": "",
                    "票": "",
                    "选择货位": "",
                    "货位类型": "",
                    "查询": "",
                    "重置": "",
                    "忽略已上架": "",
                    "入库时间": "",
                    "路线大类": "",
                    "指定路线分类": "",
                    "指定路线": "",
                    "可多选": "",
                    "客户": "",
                    "含子客户": "",
                    "操作员": "",
                    "只显示本人": "",
                    "选择运单": "",
                    "运单号码": "",
                    "转单号码": "",
                    "参考编号": "",
                    "货位编号": "",
                    "目的地": "",
                    "寄件时间": "",
                    "报关类型": "",
                    "货物类型": "",
                    "件数": "",
                    "扫描时间": "",
                    "收费重": "",
                    "收件备注": "",
                    "问题件": "",
                    "最新问题描述": "",
                    "备注": "",
                    "请选中一条数据": "",
                    "请选择货位": "",
                    "扫描单号不能为空": "",
                    "上架成功": "",
                    "请选择运单": "",
                }
            },
            "label": {
                "labeldesign": {
                    "确定要删除吗？": "",
                    "修改": "",
                    "复制": "",
                    "下载格式": "",
                    "打印或接口对接打印中选择此格式": "",
                    "格式名称": "",
                    "最新版本号": "",
                    "设计次数": "",
                    "删除": "",
                    "请选择需要上传的模版数据": "",
                    "关闭": "",
                    "格式信息": "",
                    "保存": "",
                    "测试参数必填": "",
                    "LABEL类型": "",
                    "启用": "",
                    "允许客户在": "",
                    "修改时间": "",
                    "请选择一行数据": "",
                    "只支持": "",
                    "创建人": "",
                    "修改LABEL设计": "",
                    "测试参数": "",
                    "未设置测试参数,不能预览": "",
                    "上传格式文件": "",
                    "格式": "",
                    "新增LABEL设计": "",
                    "新增": "",
                    "确定": "",
                    "提示": "",
                    "格式编码": "",
                    "成功！": "",
                    "注意": "",
                    "删除成功！": "",
                    "客户可选": "",
                    "该格式未上传模板！": "",
                    "预览格式": "",
                    "模版上传成功": "",
                    "请输入": "",
                    "修改人": "",
                    "取消": "",
                    "创建时间": "",
                    "请通过": "",
                    "设计器设计好后直接上传即可": "",
                    "修改成功！": "",
                    "类型": ""
                }
            },
            "customerroutingrules": {
                "customerroutingrules": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "显示秘钥": "",
                    "导出": "",
                    "客户打单规则": "",
                    "所属网点": "",
                    "客户": "",
                    "客户名称": "",
                    "指定路线": "",
                    "走货路线": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "启用": "",
                    "允许打印转单": "",
                    "打单走货路线规则": "",
                    "收货时验证重量": "",
                    "勾选后": "",
                    "收费重": "",
                    "打单重量": "",
                    "时": "",
                    "会自动产生问题件": "",
                    "特定代理": "",
                    "注意": "",
                    "保存并继续": "",
                    "保存": "",
                    "关闭": "",
                    "账号信息": "",
                    "格式": "",
                    "客户代号": "",
                    "账号": "",
                    "秘钥": "",
                    "复制": "",
                    "新增客户打单规则": "",
                    "请输入": "",
                    "客户编码": "",
                    "收货验证重量": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "请至少选择一行数据": "",
                    "客户账号:": "",
                    "账号:": "",
                    "秘钥:": "",
                    "指定路线:": "",
                    "请选择一行数据": "",
                    "只能选择同一个客户的打单规则数据": "",
                    "打单走货路线规则必须为固定走货路线": "",
                    "你选择的": "",
                    "条指定路线,其中": "",
                    "条开放API,是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "条已开放API,是否继续关闭?": "",
                    "开放API成功": "",
                    "关闭API成功": "",
                    "进来了": "",
                    "add/update 客户打单规则": "",
                    "只能选择一行数据": "",
                    "修改客户打单规则": "",
                    "请选择特定代理EDI": "",
                    "新增成功": "",
                    "修改成功": "",
                    "此操作将删除该客户打单规则, 是否继续?": "",
                    "请选择客户打单规则": "",
                    "删除成功": "",
                    "内容有修改,是否确认关闭？": "",
                    "此设置用于OMS排货前置和LABEL打印前置使用": "",
                    "当打单走货路线规则 = '排货走货路线'时，由系统按排货策略选取走货路线后再打单；当打单走货路线规则 = '固定走货路线'时，可设置走货路线（表示客户对应指定路线按走货路线成本价格进行结算）": "",
                    "此API信息用于开放给客户的对接参数": "",
                    "只适合于设置为“固定走货路线“的指定路线": "",
                }
            },
            "numberassignrules": {
                "numberassignrules4manifest": {
                    "新增": "",
                    "修改": "",
                    "删除": "",
                    "分配网点": "",
                    "分配客户": "",
                    "规则名称": "",
                    "单号类型": "",
                    "启用状态": "",
                    "查询": "",
                    "重置": "",
                    "号码段信息": "",
                    "使用信息": "",
                    "序号": "",
                    "增加": "",
                    "作废": "",
                    "使用状态": "",
                    "起始单号": "",
                    "终止单号": "",
                    "总份数": "",
                    "使用份数": "",
                    "作废份数": "",
                    "最新申请单号": "",
                    "最新申请时间": "",
                    "最新申请人": "",
                    "创建时间": "",
                    "创建人": "",
                    "修改时间": "",
                    "修改人": "",
                    "操作": "",
                    "解绑": "",
                    "网点": "",
                    "客户": "",
                    "指定路线": "",
                    "单号分配规则": "",
                    "启用": "",
                    "规则编码": "",
                    "校验类型": "",
                    "单号规则": "",
                    "预警份数": "",
                    "单次最大获取份数": "",
                    "单号规则说明": "",
                    "最多可分四段组成": "",
                    "第一": "",
                    "四段为固定位": "",
                    "第二": "",
                    "三段可以为流水号或校验位": "",
                    "流水号是必须项": "",
                    "也只允许一项": "",
                    "保存": "",
                    "关闭": "",
                    "备注": "",
                    "带校验位的前": "",
                    "个单号生成核对": "",
                    "生成单号": "",
                    "由于校验类型的多样性": "",
                    "为确保检验类型选择正确": "",
                    "凡有设置校验类型号码段": "",
                    "需统一生成单号": "",
                    "确认无误后": "",
                    "再做保存": "",
                    "请输入": "",
                    "请选择": "",
                    "累计总份数": "",
                    "累计可用份数": "",
                    "修改单号分配规则": "",
                    "新增单号分配规则": "",
                    "请选择需要修改的数据": "",
                    "此操作将删除该单号分配规则, 是否继续?": "",
                    "提示": "",
                    "确定": "",
                    "取消": "",
                    "该单号分配规则存在号码段，不能删除": "",
                    "请选择需要删除的数据": "",
                    "删除成功": "",
                    "删除异常": "",
                    "请选择单条数据进行查看": "",
                    "新增号码段": "",
                    "修改号码段": "",
                    "只能删除‘未使用’号码段": "",
                    "此操作将删除该号码段, 是否继续?": "",
                    "删除号码段成功": "",
                    "删除号码段异常": "",
                    "只能作废‘未使用’和‘部分使用’的号码段": "",
                    "此操作将作废该号码段, 是否继续?": "",
                    "作废号码段成功": "",
                    "作废号码段异常": "",
                    "单号规则必须含有流水号（也只允许一项）": "",
                    "单号规则不能包含中文": "",
                    "校验类型不为空，单号规则必须含有校验位": "",
                    "单号规则只能含有1个校验位": "",
                    "校验类型为空，单号规则不能含有校验位": "",
                    "新增成功": "",
                    "修改成功": "",
                    "保存异常": "",
                    "起始单号、终止单号长度必须一致": "",
                    "起始单号不符合单号规则（前缀不符）": "",
                    "终止单号不符合单号规则（前缀不符）": "",
                    "起始单号不符合单号规则（后缀不符）": "",
                    "终止单号不符合单号规则（后缀不符）": "",
                    "起始单号不符合单号规则（流水号或校验位不符）": "",
                    "终止单号不符合单号规则（流水号或校验位不符）": "",
                    "终止单号流水位必须大于起始单号流水位": "",
                    "起始单号不符合单号规则（流水号位数不符）": "",
                    "终止单号不符合单号规则（流水号位数不符）": "",
                    "新增号码段成功": "",
                    "修改号码段成功": "",
                }
            },
            "weightcollectionsettings": {
                "weightcollectionsettings": {
                    "波特率(bps)": "",
                    "确定要删除吗？": "",
                    "修改": "",
                    "采集设置": "",
                    "电子称采集设置": "",
                    "输出文本": "",
                    "转换正则表达式": "",
                    "修改电子称": "",
                    "查询": "",
                    "调整顺序超过文本值个数": "",
                    "保存": "",
                    "设备名称": "",
                    "新增电子秤成功": "",
                    "设备": "",
                    "创建人": "",
                    "修改电子秤成功！": "",
                    "组整数": "",
                    "注意": "",
                    "删除成功！": "",
                    "启用状态": "",
                    "设备ID": "",
                    "新增DWS成功": "",
                    "录单用户": "",
                    "反转": "",
                    "修改DWS成功！": "",
                    "录单网点": "",
                    "波特率": "",
                    "修改人": "",
                    "调整顺序必须5组整数": "",
                    "设备采集文本": "",
                    "电子秤": "",
                    "新增DWS": "",
                    "删除": "",
                    "关闭": "",
                    "调整顺序": "",
                    "调整顺序必须为整数或逗号": "",
                    "重置": "",
                    "启用": "",
                    "修改时间": "",
                    "新增电子秤": "",
                    "设备类型": "",
                    "端口": "",
                    "必须为": "",
                    "转换正则表达式不能为空": "",
                    "新增": "",
                    "确定": "",
                    "新增电子称": "",
                    "内容有修改,是否确认关闭？": "",
                    "提示": "",
                    "测试": "",
                    "修改DWS": "",
                    "请选择需要删除的数据": "",
                    "请输入": "",
                    "请选择需要修改的数据": "",
                    "取消": "",
                    "创建时间": "",
                    "进入": "",
                    "通过正则表达式将设备采集文本转换为数据数值，并用,隔开": "",
                    "按调整顺序，将数组按一定格式（扫描单号、长、宽、高、重量，中间用,隔开）重新排列（如对应列无值时置空），输出最终格式文本": "",
                    "在正式使用设备前，请做好测试，以确保输出文本的准确性": "",
                    "通过正则表达式将设备采集文本转换为重量": "",
                }
            },


            /* 调度 */
            "dispatch": {
                /* 取件申请 */
                "cartask": {
                    "确定要删除吗？": "",
                    "修改": "",
                    "联系人": "",
                    "登记人": "",
                    "全部": "",
                    "指定路线": "",
                    "已取消": "",
                    "查询": "",
                    "保存": "",
                    "联系电话": "",
                    "修改异常": "",
                    "新增取件信息": "",
                    "请先完善基础信息！": "",
                    "取件公司": "",
                    "预约取件时间": "",
                    "请选择": "",
                    "修改取件信息": "",
                    "删除成功！": "",
                    "删除异常": "",
                    "重量": "",
                    "货物信息": "",
                    "件数": "",
                    "司机电话": "",
                    "修改人": "",
                    "状态为‘已取件’或者‘已取消’的数据不允许修改": "",
                    "预约取件日期": "",
                    "取件状态": "",
                    "已取件": "",
                    "车牌号": "",
                    "修改成功！": "",
                    "取件地址": "",
                    "注意事项": "",
                    "司机": "",
                    "复制数据成功": "",
                    "复制新增": "",
                    "请选择取件状态为’待取件‘的数据": "",
                    "关闭": "",
                    "重置": "",
                    "销售员": "",
                    "待取件": "",
                    "修改时间": "",
                    "取件申请": "",
                    "预约备注": "",
                    "请选择一行数据": "",
                    "背景色设置": "",
                    "跟单员": "",
                    "客户": "",
                    "相等": "",
                    "客户信息": "",
                    "新增": "",
                    "确定": "",
                    "登记时间": "",
                    "提示": "",
                    "内容有修改,是否确认关闭？": "",
                    "每行高亮": "",
                    "任务单号": "",
                    "添加成功！": "",
                    "报关方式": "",
                    "导出": "",
                    "体积": "",
                    "请输入": "",
                    "取消": "",
                    "添加异常": ""
                },
                /* 车辆管理 */
                "vehicleManagement": {
                    "确定要删除吗？": "",
                    "删除车辆异常": "",
                    "修改": "",
                    "保存并继续": "",
                    "保险日期": "",
                    "查询": "",
                    "保存": "",
                    "新增车辆信息": "",
                    "创建人": "",
                    "核定重量（KG）": "",
                    "修改异常": "",
                    "品牌": "",
                    "年检日期": "",
                    "请选择": "",
                    "基本信息": "",
                    "删除成功！": "",
                    "启用状态": "",
                    "修改车辆信息": "",
                    "所属网点": "",
                    "修改人": "",
                    "车牌号": "",
                    "车辆管理": "",
                    "修改成功！": "",
                    "电话": "",
                    "司机": "",
                    "司机信息": "",
                    "备注": "",
                    "行驶证号": "",
                    "删除": "",
                    "核定重量": "",
                    "关闭": "",
                    "重置": "",
                    "启用": "",
                    "修改时间": "",
                    "请选择一行数据": "",
                    "背景色设置": "",
                    "驾驶证": "",
                    "相等": "",
                    "新增": "",
                    "确定": "",
                    "最大载重": "",
                    "提示": "",
                    "内容有修改,是否确认关闭？": "",
                    "体积（m³）": "",
                    "每行高亮": "",
                    "最大载重（KG）": "",
                    "添加成功！": "",
                    "车型": "",
                    "导出": "",
                    "体积": "",
                    "请输入": "",
                    "取消": "",
                    "创建时间": "",
                    "添加异常": ""
                },
                /* 调度区域 */
                "carline": {
                    "确定要删除吗？": "",
                    "修改": "",
                    "区域名称": "",
                    "联系人": "",
                    "保存并继续": "",
                    "区域管理": "",
                    "当前车辆删除成功": "",
                    "途径地点": "",
                    "代理": "",
                    "周二取件时间点": "",
                    "可以输入多个": "",
                    "查询": "",
                    "保存": "",
                    "周一取件时间点": "",
                    "联系电话": "",
                    "周六取件时间点": "",
                    "周四取件时间点": "",
                    "终止时间": "",
                    "创建人": "",
                    "修改异常": "",
                    "结束时间": "",
                    "请先完善基础信息！": "",
                    "操作": "",
                    "请选择": "",
                    "基本信息": "",
                    "删除成功！": "",
                    "启用状态": "",
                    "删除区域异常": "",
                    "所属网点": "",
                    "修改人": "",
                    "调度区域": "",
                    "修改成功！": "",
                    "取件地址": "",
                    "此操作将删除该车辆, 是否继续?": "",
                    "送货地址": "",
                    "增加": "",
                    "备注": "",
                    "周五取件时间点": "",
                    "删除": "",
                    "关闭": "",
                    "修改区域信息": "",
                    "重置": "",
                    "启用": "",
                    "此操作将删除该代理, 是否继续?": "",
                    "修改时间": "",
                    "请选择一行数据": "",
                    "背景色设置": "",
                    "退件任务": "",
                    "起始时间": "",
                    "客户": "",
                    "相等": "",
                    "当前代理删除成功": "",
                    "新增": "",
                    "确定": "",
                    "多个之间用中文逗号分隔": "",
                    "提示": "",
                    "内容有修改,是否确认关闭？": "",
                    "每行高亮": "",
                    "周三取件时间点": "",
                    "周日取件时间点": "",
                    "出货代理": "",
                    "添加成功！": "",
                    "当前客户删除成功": "",
                    "导出": "",
                    "此操作将删除该客户, 是否继续?": "",
                    "请输入": "",
                    "取消": "",
                    "创建时间": "",
                    "取件客户": "",
                    "新增区域信息": "",
                    "添加异常": "",
                    "区域编码": "",
                    "默认车辆": ""
                },
                /* 调度管理 */
                "carSchedulingManagement": {
                    "确定要删除吗？": "",
                    "重新分配": "",
                    "已确认": "",
                    "总重量/车辆载重": "",
                    "调度日期": "",
                    "客户/代理": "",
                    "修改调度信息": "",
                    "分配": "",
                    "原件信息": "",
                    "保存": "",
                    "调度": "",
                    "出货任务数": "",
                    "拆单信息": "",
                    "待确认任务数": "",
                    "已完成": "",
                    "取消调度数据异常": "",
                    "拆单件数不能比原件数大": "",
                    "退件任务数": "",
                    "请选择": "",
                    "注意": "",
                    "异常备注": "",
                    "重新分配异常": "",
                    "选择调度区域": "",
                    "任务总数": "",
                    "件数": "",
                    "取件任务数": "",
                    "取件/送货地址": "",
                    "取消任务": "",
                    "车牌号": "",
                    "调度区域": "",
                    "待分配": "",
                    "待调度": "",
                    "注意事项": "",
                    "拆单": "",
                    "司机": "",
                    "任务日期": "",
                    "待确认": "",
                    "可直接双击表格选中的数据即可完成分配": "",
                    "重置": "",
                    "重新分配成功！": "",
                    "请先完善调度信息！": "",
                    "请选择任务状态为待确认的数据": "",
                    "相等": "",
                    "请选择待调度任务数大于0的数据": "",
                    "转运任务数": "",
                    "新任务单号": "",
                    "提示": "",
                    "确": "",
                    "分配时间": "",
                    "导出": "",
                    "请输入": "",
                    "待调度任务数": "",
                    "取消": "",
                    "异常": "",
                    "区域编码": "",
                    "取消任务异常": "",
                    "调度数据异常": "",
                    "联系人": "",
                    "消": "",
                    "分配成功！": "",
                    "输入区域编码或名称按回车键搜索": "",
                    "全部": "",
                    "已取消": "",
                    "查询": "",
                    "当日调度": "",
                    "联系电话": "",
                    "定": "",
                    "取消任务成功！": "",
                    "请选择任务状态为待调度的数据": "",
                    "来日调度": "",
                    "重量": "",
                    "请选择任务状态为待分配或者待调度的数据": "",
                    "司机电话": "",
                    "任务状态": "",
                    "取消调度成功！": "",
                    "请选择数据并且一条": "",
                    "总体积/车辆体积": "",
                    "总件数": "",
                    "备注": "",
                    "分配异常": "",
                    "小时内超时": "",
                    "调度管理": "",
                    "关闭": "",
                    "销售员": "",
                    "取": "",
                    "分配人": "",
                    "数据来源": "",
                    "如果无需修改调度信息": "",
                    "预约备注": "",
                    "完成时间": "",
                    "请选择一行数据": "",
                    "背景色设置": "",
                    "任务类型": "",
                    "跟单员": "",
                    "请选择待确认任务数大于0的数据": "",
                    "撤销调度": "",
                    "确定": "",
                    "调度信息": "",
                    "确认时间": "",
                    "内容有修改,是否确认关闭？": "",
                    "每行高亮": "",
                    "调度成功！": "",
                    "任务单号": "",
                    "分配调度区域": "",
                    "体积": "",
                    "车牌号码": ""
                },
                /* 调度查询 */
                "cartaskquery": {
                    "联系人": "",
                    "注意事项": "",
                    "总件数": "",
                    "总重量/车辆载重": "",
                    "调度日期": "",
                    "司机": "",
                    "客户/代理": "",
                    "任务日期": "",
                    "备注": "",
                    "查询": "",
                    "出货任务数": "",
                    "重置": "",
                    "销售员": "",
                    "联系电话": "",
                    "分配人": "",
                    "预约备注": "",
                    "完成时间": "",
                    "任务类型": "",
                    "跟单员": "",
                    "确认时间": "",
                    "转运任务数": "",
                    "退件任务数": "",
                    "异常任务数": "",
                    "异常备注": "",
                    "任务单号": "",
                    "重量": "",
                    "分配时间": "",
                    "任务总数": "",
                    "件数": "",
                    "明细": "",
                    "取件任务数": "",
                    "体积": "",
                    "司机电话": "",
                    "车牌号码": "",
                    "取件/送货地址": "",
                    "车牌号": "",
                    "任务状态": "",
                    "调度区域": "",
                    "总体积/车辆体积": ""
                }
            },


		},
        "CMN10010":{
            "尾程": 'End journey',
            "目的地编码": 'destination code',
            "查询": 'Query',
            "自提点代码": 'Pickup point code',
            "尾程自提点代码": 'Last-mile pickup point code',
            "类型": 'Type',
            "名称": 'Name',
            "国家码": 'Country code',
            "省": 'Province',
            "市": 'City',
            "区": 'District',
            "详细地址": 'Detailed address',
            "邮编": 'Postal code',
            "电话": 'Telephone number',
        },
    },
    "components": {
        "problemsRegistration": {
            "index": {
                "只能上传jpg/png/word/excel/pdf文件": "",
                "点击上传附件": "",
                "问题状态": "",
                "登记成功！": "",
                "运单号码": "",
                "关闭": "",
                "可上传一个后缀名为": "",
                "可多选": "",
                "问题描述": "",
                "登记": "",
                "指定处理人": "",
                "附件": "",
                "确定": "",
                "文件大小不能大于15MB": "",
                "通知人": "",
                "内容有修改,是否确认关闭？": "",
                "提示": "",
                "大小不能超过": "",
                "处理时限": "",
                "问题件信息": "",
                "处理网点": "",
                "请输入": "",
                "获取运单信息失败！": "",
                "登记异常": "",
                "获取问题状态信息失败！": "",
                "取消": "",
                "的附件": ""
            }
        }
    }

};
export default enUS;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/locale/en-US.js